// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-10T15:14:07.128Z
// Property: Noho (ID: 6767906449167727)
// Collections: 63 amenities, 21 floorplans (live), 70 photos, 69 POIs, 84 reviews, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167727",
  "property_external_id": "hk5bdj2",
  "property_zillow_url": "https://www.zillow.com/apartments/tampa-fl/noho-flats-i-and-ii/5Xrn85/",
  "property_apartments_url": "https://www.apartments.com/noho-flats-i-and-ii-tampa-fl/hk5bdj2/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "noho",
  "property_name": "Noho",
  "property_website_url": "https://noho-theme.multiscreensite.com/",
  "property_domain": null,
  "property_address": "123 Roman Ave",
  "property_full_address": "123 Roman Ave, Tampa, FL 33606",
  "property_address_1": "123 Roman Ave",
  "property_address_2": null,
  "property_address_city": "Tampa",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "33606",
  "property_address_country": "US",
  "property_address_county": "Hillsborough County",
  "property_neighborhood_address": "North Hyde Park",
  "property_address_latitude": "27.9478737",
  "property_address_longitude": "-82.4761905",
  "property_email": null,
  "property_phone": "5555555555",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Front-row Tampa living starts at NoHo Flats.</strong> Recharge with a saltwater pool, fitness center, yoga room, fire pits, and courtyard grilling, then head out with easy interstate access for beach-day plans. Schedule your tour today.</p>",
  "property_long_description": "<p><strong>Brand-new energy meets Hyde Park character at Noho.</strong> Set in North Hyde Park, these one-, two-, and three-bedroom apartments pair newly built and renovated layouts with quartz countertops, stainless steel appliances, wood-style flooring, in-home washer/dryer, and designer lighting, so your space feels polished from day one.</p><p>Beyond your front door, the community gives you room to unwind, focus, and connect: a saltwater pool with cabanas and sundeck, outdoor fire pits and grilling stations, fitness and yoga studio, club lounges with WiFi and billiards, conference rooms, coffee bar, pet park, and pet spa. Explore the full <a href=\"/amenities\">amenity collection</a> or compare <a href=\"/floor-plans\">available floor plans</a> to find the layout that fits your day.</p><p>Step into a North Hyde Park address close to Willa’s, Buddy Brew Coffee, Hyde Park Village, the University of Tampa, Julian B. Lane Riverfront Park, and quick routes to Downtown Tampa and I-275. Here, Tampa dining, shopping, parks, and city life stay comfortably within reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
    "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
    "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "311",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "76.52733118971061",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Pet Limit: 2. Weight Limit: 100 lbs. Restricted Breeds: Call for details.",
  "property_pet_policy_description": "One-Time Pet Fee: $400–600. Pet Limit: 2. Weight Limit: 100 lbs. Restricted Breeds: Call for details.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-9542-71f5-9ac5-c523aac2d8a9.webp",
  "property_primary_logo_media": {
    "alt_text": "NOHO logo",
    "public_id": "01a03516-9542-71f5-9ac5-c523aac2d8a9",
    "storage_key": "property/6767906449167727/01a03516-9542-71f5-9ac5-c523aac2d8a9.webp",
    "width": 320,
    "height": 96
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-9535-7426-9d5c-b91d17735e73.webp",
  "property_secondary_logo_media": {
    "alt_text": "NOOH logo",
    "public_id": "01a03516-9535-7426-9d5c-b91d17735e73",
    "storage_key": "property/6767906449167727/01a03516-9535-7426-9d5c-b91d17735e73.webp",
    "width": 1000,
    "height": 300
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-1301-7250-a7df-7c40349d61e9.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03518-1301-7250-a7df-7c40349d61e9",
    "storage_key": "property/6767906449167727/01a03518-1301-7250-a7df-7c40349d61e9.webp",
    "width": 320,
    "height": 96
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-07e6-763c-a601-ae6b5bc29883.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03518-07e6-763c-a601-ae6b5bc29883",
    "storage_key": "property/6767906449167727/01a03518-07e6-763c-a601-ae6b5bc29883.webp",
    "width": 320,
    "height": 96
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#6b0f36",
  "property_secondary_color": "#8cc3c2",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "621 - 1,293 sq ft",
  "property_sqft_min": "621",
  "property_sqft_max": "1,293",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 73,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHRF9dX7DwogREj9C7ayNSOo",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Noho",
  "property_home_romance_title": "Embrace the Charm of Your Perfect Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Spaces for every part of the day.</strong> Fuel up in the lounge, focus in the business center or conference room, stretch in the fitness and yoga studio, then unwind at the saltwater pool with cabanas, a sundeck, and outdoor kitchen. Courtyard grills, fire pits, billiards, club spaces, pet perks, and polished apartment finishes bring the Noho experience together.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Noho offers one-, two-, and three-bedroom apartments in North Hyde Park, including brand-new homes and renovated designs. Look for clean finishes, stainless steel appliances, quartz-style surfaces, rich cabinetry, wood-style flooring, walk-in storage, in-home laundry, and select private patios or balconies—then compare featured floor plans and find the space that matches your day-to-day rhythm.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Noho in full color.</strong> Preview polished interiors with wood-style floors, stainless steel appliances, and crisp white or rich wood cabinetry, then look beyond your front door to a saltwater pool with cabanas, courtyard grills, a WiFi lounge with billiards, a fitness and yoga studio, and pet-friendly perks in North Hyde Park.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Hyde Park keeps Tampa close.</strong> Step out near Fig Street flavor and Rome Avenue ease, with Willa’s Provisions, Rome + Fig, quick groceries, and local staples close by. Cigar-factory brick, early bungalows, and evolving streetscapes give the area its old Tampa texture, while Downtown, the Riverwalk, Hyde Park Village, SoHo dining, and the Green Spine cycle track stay within an easy radius.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about Noho.</strong> Reviews point to responsive leasing support, service requests handled with “efficiency and urgency,” and helpful guidance from move-in through everyday needs.</p><p>They also call out friendly communication, renovated apartment homes, quiet pockets of the community, and a central Tampa location that keeps daily plans close. Read more to see what life at Noho feels like from the resident perspective.</p>",
  "property_neighborhood_blurb": "<p><strong>North Hyde Park puts Tampa on an easy radius.</strong> From Noho, you’re set near Fig Street flavor and Rome Avenue convenience—morning coffee at Willa’s Provisions, dinner at Rome + Fig, quick groceries, and neighborhood staples all close enough to make the map feel immediately useful. The area blends old Tampa texture—cigar-factory brick, early bungalows, and evolving streetscapes—with a central location just west of Downtown.</p><p>Follow Cass Street to the Green Spine cycle track for a bike connection toward the Riverwalk and Ybor, head south for Hyde Park Village and SoHo dining, or cross into Downtown for events, waterfront parks, and city energy. When you want to see how home base fits into it all, browse the <a href=\"/gallery\">community spaces</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that move with your day.</strong> Start with coffee in the lounge, take your laptop to the business center or conference room, then reset in the fitness and yoga studio before heading to the saltwater pool, sundeck, cabanas, and outdoor kitchen. Courtyard grilling stations, fire pits, billiards, and relaxed club spaces give you easy places to gather, unwind, or simply change the scenery.</p><p>At home, brand-new and renovated <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a> pair everyday function with polished finishes, including stainless steel appliances, wood-style flooring, rich cabinetry, high-speed WiFi access, and in-home washer and dryer convenience. Pets get thoughtful perks, too, with dog parks, a pet play area, and a wash station—learn more on the <a href=\"/pet-policy\">pet policy</a> page or see the spaces in the <a href=\"/gallery\">photo gallery</a>.</p>",
  "property_applynow_blurb": "<p><strong>Find your front-row seat to Tampa living.</strong> NoHo Flats brings home the Florida lifestyle with relaxing outdoor spaces, a saltwater pool, fitness options, and easy access to the interstate and beach days. Ready to make it yours? Start your application online today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the NoHo Flats leasing team to learn more about our front-row Tampa location, relaxing outdoor spaces, and saltwater pool lifestyle. We’re here to help you plan your visit or schedule a tour.</p>",
  "property_faqs_blurb": "<p><strong>Questions about NoHo Flats?</strong> You’re in the right place. Explore quick answers about the community, leasing, amenities, and everyday living here, from the saltwater pool to the fitness and outdoor spaces. If you need more details or want to see it in person, our leasing team is happy to help you schedule a tour.</p>",
  "property_floorplans_blurb": "<p><strong>Find the space that fits your rhythm.</strong> At Noho, the floor plan lineup gives you room to choose—efficient one-bedroom apartments, flexible two-bedroom layouts, and a three-bedroom residence with the added comfort of three baths. Select from brand-new homes or renovated designs, each shaped by clean finishes and practical everyday details.</p><p>Inside, your layout may include stainless steel appliances, quartz-style surfaces, rich cabinetry, wood-style flooring, walk-in storage, and an in-home washer and dryer. Some homes add a private patio or balcony for an easy indoor-outdoor moment. Compare available layouts, pricing, and move-in timing, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see which North Hyde Park apartment feels like the right fit.</p>",
  "property_gallery_blurb": "<p><strong>See Noho from the best angle.</strong> Browse bright interiors where wood-style flooring, white or rich wood cabinetry, and stainless steel appliances create a clean, polished backdrop for everyday living. The gallery moves from open kitchens and comfortable living areas to renovated and brand-new layouts, helping you compare the feel of each home before you explore <a href=\"/floor-plans\">available floor plans</a>.</p><p>Then step into the shared spaces: a saltwater pool edged with loungers and cabanas, courtyard grilling areas made for easy evenings outside, a WiFi lounge with billiards, and quiet corners for coffee or a laptop. From the fitness and yoga studio to the pet park and wash station, each image gives you a clearer sense of the <a href=\"/amenities\">amenities</a> waiting in North Hyde Park.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore NoHo Flats from every angle.</strong> Use the interactive map to browse available apartments, see how the community connects to NoHo, and picture your days close to Tampa’s energy—with the interstate nearby for sunny beach afternoons.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash, not the extra errands.</strong> At Noho, pet-friendly living in North Hyde Park is built into the routine: a community pet park for quick outdoor breaks, dog park space for everyday exercise, and an on-site pet spa/wash station for rinse-offs after wet sidewalks, muddy paws, or playtime.</p><p>Back at home, choose from one-, two-, and three-bedroom layouts with practical finishes like wood-style flooring and in-home washer/dryer convenience, then keep your day moving with courtyards, outdoor lounges, and connected <a href=\"/amenities\">community amenities</a> just beyond your door. Review the policy details shown here, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Noho makes life with pets feel easier.</p>",
  "property_referafriend_blurb": "<p><strong>Love life in the front row of Tampa?</strong> Share NoHo Flats with a friend and invite them to enjoy the saltwater pool, fitness center, yoga room, fire pits, grilling spaces, and easy access to the Florida lifestyle you already know. Send a referral today and help them find their place here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at NoHo Flats</strong><br>Home is your front row to Tampa living—now your account is just as easy to reach. Log in to pay rent, submit maintenance requests, and manage details, then get back to the saltwater pool, fitness center, courtyard grills, and everything else that makes home feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Noho.</strong> Reviews consistently highlight the people who make daily life feel supported, from a responsive leasing team to a service team praised for “efficiency and urgency.”</p><p>You’ll see residents call out warm communication, helpful move-in guidance, and friendly support from team members including Destiny, Way, Samantha, Waynnisha, and Wilson. Many also mention the welcoming community, quiet corners of the property, renovated apartment homes, and a convenient central Tampa location. Read the reviews below to get a real sense of what it’s like to call Noho home.</p>",
  "property_created_at": "1787597015686",
  "property_scheduletour_blurb": "<p><strong>See NoHo Flats in person.</strong> From the saltwater pool to the fitness center, yoga room, fire pits, and courtyard grilling stations, every space is designed for easy Florida living. Come experience the energy, comfort, and location for yourself—schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> We’ve received your inquiry, and the NoHo Flats leasing team will follow up soon. From a saltwater pool to inviting outdoor spaces and a prime Tampa location, this is a place designed to make everyday living feel bright, easy, and connected.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Noho before you arrive.</strong> Start with the spaces that shape daily life: the courtyard, pool, fitness center, and the game room + pool tour, where you can turn through seating areas, activity zones, and outdoor gathering spots at your own pace. Then step inside apartment tours for homes 4120, 4210, 3335, and 2301 to compare real layouts, kitchen flow, room proportions, finish palettes, and storage moments from your screen.</p><p>Use these virtual tours to narrow what feels right, then pair what you see with current <a href=\"/floor-plans\">floor plan options</a> or book an in-person look when you are ready. Whether you are exploring from across Tampa or across the map, Noho’s tour library gives you a clearer sense of the community before you visit.</p>",
  "property_copyright": "2026 All Rights Reserved. Noho",
  "property_seo_title_home": "Noho |  Apartments in Tampa, FL",
  "property_seo_description_home": "Discover vibrant living at Noho Tampa! Choose from luxury one to three-bedroom apartments with pet-friendly amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Tampa, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Noho in Tampa, FL! Choose from stylish one, two, or three-bedroom floor plans that suit your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Tampa, FL Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Noho in Tampa! Enjoy luxury amenities like a fitness center, pet spa, and outdoor lounges. Your perfect home awaits—come feel the vibe!",
  "property_seo_title_gallery": "Gallery | Apartments in Tampa, FL",
  "property_seo_description_gallery": "Imagine life at Noho in Tampa, FL! Stunning amenities, vibrant community spaces, and pet-friendly features await you. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Noho Apartments",
  "property_seo_description_virtualtours": "Experience Noho in Tampa, FL! Take a virtual tour of our stunning one, two, and three-bedroom apartments. Your dream home awaits—step inside today!",
  "property_seo_title_interactivemap": "Interactive Map | Noho Apartments",
  "property_seo_description_interactivemap": "Find your perfect sanctuary at Noho in Tampa! Our interactive map lets you explore spacious floor plans and vibrant amenities tailored for your lifestyle.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tampa, FL",
  "property_seo_description_neighborhood": "Discover Tampa's Noho neighborhood! From hidden gems to local favorites, explore what awaits right outside your door. Embrace your new lifestyle!",
  "property_seo_title_contact": "Contact Us | Noho",
  "property_seo_description_contact": "Got questions about Noho? Our Tampa community offers one to three-bedroom floor plans. Reach out to our leasing team today for friendly assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Tampa, FL",
  "property_seo_description_faqs": "Find answers to all your questions about Noho in Tampa, FL! From floor plans to pet amenities, our FAQs have you covered. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tampa, FL",
  "property_seo_description_reviews": "Join the vibrant Noho community in Tampa! Hear from residents about our pet-friendly amenities, stunning renovations, and exciting social events.",
  "property_seo_title_applynow": "Apply Now | Apartments in Tampa, FL",
  "property_seo_description_applynow": "Discover Noho in Tampa, FL: modern comfort, scenic outdoor spaces, saltwater pool, and pet-friendly amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Noho",
  "property_seo_description_residentaccess": "Log in to Noho’s resident portal for seamless rent payments, maintenance requests, and community updates. Your Tampa home just got smarter!",
  "property_seo_title_referafriend": "Refer A Friend | Noho",
  "property_seo_description_referafriend": "Refer a friend to Noho in Tampa, FL! Great friends make great neighbors—share the unique lifestyle and vibrant community waiting for them at Noho today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Noho",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Noho in Tampa, FL. Schedule your tour today and envision your new home in our welcoming, modern community!",
  "property_seo_title_privacy": "Privacy Policy | Noho",
  "property_seo_description_privacy": "At Noho in Tampa, your privacy matters. Learn how we protect your personal information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Noho",
  "property_seo_description_accessibility": "At Noho in Tampa, we champion accessibility for all. Our commitment to inclusivity ensures everyone can enjoy a seamless online experience. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Noho",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Noho in Tampa, FL. Check out our sitemap to uncover all that our vibrant community has to offer!",
  "property_seo_title_thankyou": "Thank You | Noho",
  "property_seo_description_thankyou": "Thank you for reaching out to Noho in vibrant Tampa! Our team will be in touch soon to assist you with your apartment journey. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tampa, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789049806157",
  "amenities": [
    {
      "id": "ec_44e46fb902c13d2241e8a8a6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c270f383e5a621f4a52d608",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6cecd25a97d3769724cab862",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e03c04a75d27f9945b0779b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8f24590e525e15982518e3c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4be898f929359d8803318bed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_045691e10fa053a7053773ab",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b8030bb22b51caffd560fc3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e89315dc86044f1a06233de4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4735907e1b6c1d46940e863d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6675adcca2a7fb511cea670",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e77808af4d06fe0e159edd1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3deb7437031b0fd9036c4c33",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef70b49c6d88821d6d1fd990",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ca592f970046feeb1cddf5a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28be943bbac857571390119e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_710842f69e6eebf99cb52f23",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "1 Bed Platinum Renovation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83fc0b200bbd4f0a900a3fff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "2 Bed Platinum Renovation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d7ec7195a02bea984f55c3e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "3 Bed Platinum Renovation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_961224f7e5c8bd574bdc90f1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "A/C Units",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f397fcd15cac99b3fb1a1ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "AC",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43d398eb1f1850cf900a0ab8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9075bd82a8de50bbf308388",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Club Lounges with WiFi & Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_214742a57263b964181d871d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e18c208dd5f3a4f9761ff285",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26db4d7238c07e89359f14a3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c20423eee6f8eb14d32beb1b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Dog Parks & Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7425eef752bcb44662b8fcc7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness and Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_910012db3a798fe0e4f9007b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d57d635e815fb1cce46bfcd5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "High-Speed Internet & WiFi Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2146e4a9b0b6a1f42e153f3a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Living Space with Fire Pits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07f625d668906af9e7b01345",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07c6a3eb4356c5d31571ce4d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Patio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a20938e94949fe3caa1ab5bb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f39f2b18710998eaf51e3fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Platinum Flooring - 1",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea1533c22d37f86be3306322",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Platinum Flooring - 2",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1d1b07d9712f5660805fd97",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Platinum Flooring - 3",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9a716c0974b4924be8e462e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Poolside Cabanas, Sundeck & Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75fd3f3c07bd8c79ec4b8dd2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident social events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fb587fe478dabcf3fc3e34d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Rich Wood Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a2a416545febee8e65080b1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Tampa`s Most Pet Friendly Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0432622c929276756eaa915",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Top floor 2",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc9d25ca38ea3ed282dd3b64",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer / Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5de853b3307f2528a9b5226",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Water Feature",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d288da375419647243819e0a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "White Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a63944c9d6ef22e47e9c7acb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59a640beb06285cd8d32ad4d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9639aa51519476a20599f4f8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e375e01b77f8866e54ef5d19",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fdb02ec808ac75402a128ff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e4f86a95e9672010ce943ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d3b9a98adcf62600d0f566f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8d72d5c141c2aaa283fe675",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5268fb5618b9a15d36090c81",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_547eb3dfcb0c3888430d4f1b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f391ec3527df7679cbb244ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9639470ee5e7c5285e33523d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cec57d967fd16bd5ba67f778",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_858e4a2ffba8ac8ebf1e1145",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bc369e11750b1c7bdc3082f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8108097c605b75a2c2415a4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9aad6a4cb6c0e2f2415b9d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Garden",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_777b7092eda46f5ca632e067",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6b0f6725-90be-409b-8883-41a362cda77f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-fe80-779d-bb7a-b7fd2f895f62.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a Star Wars pinball machine, abstract art, and stylish pendant lights.",
        "public_id": "01a070c1-fe80-779d-bb7a-b7fd2f895f62",
        "storage_key": "property/6767906449167727/01a070c1-fe80-779d-bb7a-b7fd2f895f62.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy entertainment in our modern lounge featuring a Star Wars pinball machine, vibrant abstract art, and chic pendant lighting, perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Modern lounge area with a Star Wars pinball machine, abstract art, and stylish pendant lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f612f93-f16b-4195-b86d-e0b18ccb81e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-f216-7249-b94d-77a2aed64813.webp",
      "image_media": {
        "alt_text": "Community game room with shuffleboard, pinball machine, and chess table.",
        "public_id": "01a070c1-f216-7249-b94d-77a2aed64813",
        "storage_key": "property/6767906449167727/01a070c1-f216-7249-b94d-77a2aed64813.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in the community game room, featuring a shuffleboard, pinball machine, and a chess table for friendly competition.",
      "link": "",
      "alt_text": "Community game room with shuffleboard, pinball machine, and chess table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42992cf1-a3bd-460f-81b1-03b4170e9a74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-e3a1-719f-931b-15b1d9db5c75.webp",
      "image_media": {
        "alt_text": "Game room with skeeball and pinball machines and abstract art.",
        "public_id": "01a070c1-e3a1-719f-931b-15b1d9db5c75",
        "storage_key": "property/6767906449167727/01a070c1-e3a1-719f-931b-15b1d9db5c75.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy hours of fun in our community game room, featuring classic arcade games like skeeball and pinball, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Game room with skeeball and pinball machines and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_36140416-7915-4c66-a255-d741396fe3e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-d5e0-73be-bb71-e042116932c6.webp",
      "image_media": {
        "alt_text": "Vending machine in a gym.",
        "public_id": "01a070c1-d5e0-73be-bb71-e042116932c6",
        "storage_key": "property/6767906449167727/01a070c1-d5e0-73be-bb71-e042116932c6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Conveniently located vending machine offering snacks and drinks within the community's modern fitness center.",
      "link": "",
      "alt_text": "Vending machine in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4329e5e-b44d-4e20-a57d-eabb738d6e59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-d7db-77e8-a20e-a76e38d4c357.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio equipment and motivational wall art.",
        "public_id": "01a070c1-d7db-77e8-a20e-a76e38d4c357",
        "storage_key": "property/6767906449167727/01a070c1-d7db-77e8-a20e-a76e38d4c357.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines and an inspiring atmosphere.",
      "link": "",
      "alt_text": "Modern gym with cardio equipment and motivational wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08b7faee-2b3e-455d-9ef0-809de21642b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-da8f-7082-a35e-b151d3951115.webp",
      "image_media": {
        "alt_text": "Modern gym with a large fan, exercise equipment, and a vibrant palm tree mural.",
        "public_id": "01a070c1-da8f-7082-a35e-b151d3951115",
        "storage_key": "property/6767906449167727/01a070c1-da8f-7082-a35e-b151d3951115.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-tier equipment and an inspiring tropical mural.",
      "link": "",
      "alt_text": "Modern gym with a large fan, exercise equipment, and a vibrant palm tree mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7ea043c-98ab-41c9-a19c-3028e8d23dad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-d190-70f3-b267-b785a15ca67a.webp",
      "image_media": {
        "alt_text": "Gym with weight benches and dumbbell racks",
        "public_id": "01a070c1-d190-70f3-b267-b785a15ca67a",
        "storage_key": "property/6767906449167727/01a070c1-d190-70f3-b267-b785a15ca67a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Modern apartment gym featuring weight benches, a wide selection of dumbbells, and cardio machines. Perfect for your fitness routine.",
      "link": "",
      "alt_text": "Gym with weight benches and dumbbell racks",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d8796ca-27a5-4f5b-b609-14ee442b7f05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-c452-7158-aa09-d1cc88428a05.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with two wicker daybeds in a courtyard.",
        "public_id": "01a070c1-c452-7158-aa09-d1cc88428a05",
        "storage_key": "property/6767906449167727/01a070c1-c452-7158-aa09-d1cc88428a05.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable wicker daybeds perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor lounge area with two wicker daybeds in a courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70e8f1c3-3106-4a5c-b51c-dde77d8fa7fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-ba92-72a5-9366-1355ed19055a.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a resort-style swimming pool and lounge chairs at sunset.",
        "public_id": "01a070c1-ba92-72a5-9366-1355ed19055a",
        "storage_key": "property/6767906449167727/01a070c1-ba92-72a5-9366-1355ed19055a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy resort-style living in this beautiful apartment community, featuring a sparkling swimming pool, ample lounge seating, and a vibrant courtyard perfect for relaxation.",
      "link": "",
      "alt_text": "Apartment complex courtyard with a resort-style swimming pool and lounge chairs at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e620c29-8730-4094-b26d-d877847e69bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-b784-7147-a56c-ce4a8eef26a8.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with a Big Green Egg grill and built-in barbecue.",
        "public_id": "01a070c1-b784-7147-a56c-ce4a8eef26a8",
        "storage_key": "property/6767906449167727/01a070c1-b784-7147-a56c-ce4a8eef26a8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community's premium grilling station, featuring a Big Green Egg and spacious counter space.",
      "link": "",
      "alt_text": "Outdoor kitchen area with a Big Green Egg grill and built-in barbecue.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1afa44e8-4109-4777-9004-ae9cdaba7f61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-b190-7760-878f-288983faa665.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge chairs and cabanas",
        "public_id": "01a070c1-b190-7760-878f-288983faa665",
        "storage_key": "property/6767906449167727/01a070c1-b190-7760-878f-288983faa665.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor pool, surrounded by comfortable seating and shaded cabanas. Perfect for soaking up the sun or enjoying a cool dip.",
      "link": "",
      "alt_text": "Outdoor pool area with lounge chairs and cabanas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5740057f-3456-4986-bc1e-75e5a67af6cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-e46a-7028-b803-cb4db9e215c4.webp",
      "image_media": {
        "alt_text": "Outdoor seating area on apartment balcony with two chairs and a small table.",
        "public_id": "01a03518-e46a-7028-b803-cb4db9e215c4",
        "storage_key": "property/6767906449167727/01a03518-e46a-7028-b803-cb4db9e215c4.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, furnished with comfortable seating and a charming side table.",
      "link": "",
      "alt_text": "Outdoor seating area on apartment balcony with two chairs and a small table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c127c171-6a6e-4850-8f4f-3b8b051fd66b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-d54e-734a-8dfb-7d698ec52cfb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a red espresso machine.",
        "public_id": "01a03518-d54e-734a-8dfb-7d698ec52cfb",
        "storage_key": "property/6767906449167727/01a03518-d54e-734a-8dfb-7d698ec52cfb.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, a sleek backsplash, and a vibrant red espresso machine for your morning coffee.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and a red espresso machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_226399b7-a0a0-469f-a74a-b4fe81c84225",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-c87f-7033-9d21-76e29453fd74.webp",
      "image_media": {
        "alt_text": "Pet spa with grooming station and dog dryer.",
        "public_id": "01a03518-c87f-7033-9d21-76e29453fd74",
        "storage_key": "property/6767906449167727/01a03518-c87f-7033-9d21-76e29453fd74.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "State-of-the-art pet spa for all your pet's needs. Come on in and relax with our convenient grooming station and high-quality dryer.",
      "link": "",
      "alt_text": "Pet spa with grooming station and dog dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_173505ec-b6d9-454e-b066-5082fcff83fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-c411-708b-bd06-89906b24d220.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "01a03518-c411-708b-bd06-89906b24d220",
        "storage_key": "property/6767906449167727/01a03518-c411-708b-bd06-89906b24d220.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a king-size bed, bedside lamps, and a decorative wall art. Enjoy comfort and style in this beautifully designed living space.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7abf95d-c39f-431d-8eeb-4d27b37e51eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-bea9-73ec-ac3c-10cab9118fe9.webp",
      "image_media": {
        "alt_text": "Modern living room and open-concept kitchen with island seating",
        "public_id": "01a03518-bea9-73ec-ac3c-10cab9118fe9",
        "storage_key": "property/6767906449167727/01a03518-bea9-73ec-ac3c-10cab9118fe9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living area flows seamlessly into a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and open-concept kitchen with island seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_585b3118-2d2c-43fc-80cd-ce0ce739abd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-aaaa-72e6-97fe-0c4c7fe7f64e.webp",
      "image_media": {
        "alt_text": "Dining area and living room with a curved sofa, coffee table, and decorative plants.",
        "public_id": "01a03518-aaaa-72e6-97fe-0c4c7fe7f64e",
        "storage_key": "property/6767906449167727/01a03518-aaaa-72e6-97fe-0c4c7fe7f64e.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living and dining area, perfect for entertaining guests or relaxing after a long day.",
      "link": "",
      "alt_text": "Dining area and living room with a curved sofa, coffee table, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd15cba0-f1c0-48b1-a5e4-cb63968c4996",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a950-73e8-8426-9cd2606ddcbb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and a large island.",
        "public_id": "01a03518-a950-73e8-8426-9cd2606ddcbb",
        "storage_key": "property/6767906449167727/01a03518-a950-73e8-8426-9cd2606ddcbb.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample counter space, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_189c7366-896e-4f95-96a9-e9d0611064f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a6ef-711b-93e2-70197deb7a3d.webp",
      "image_media": {
        "alt_text": "Home office setup with a desk, computer, exercise equipment, and dumbbells.",
        "public_id": "01a03518-a6ef-711b-93e2-70197deb7a3d",
        "storage_key": "property/6767906449167727/01a03518-a6ef-711b-93e2-70197deb7a3d.webp",
        "width": 2000,
        "height": 1330
      },
      "title": "Apartment",
      "description": "This versatile space can function as a home office or a personal gym, featuring a comfortable desk with a computer, a stepper machine, and a yoga ball.",
      "link": "",
      "alt_text": "Home office setup with a desk, computer, exercise equipment, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ca66865-d1d1-443c-ae02-0ae656dbb429",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a489-7004-9fcb-fe16f2bee3b6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, black faucet, illuminated mirror, bathtub, and teal shower curtain.",
        "public_id": "01a03518-a489-7004-9fcb-fe16f2bee3b6",
        "storage_key": "property/6767906449167727/01a03518-a489-7004-9fcb-fe16f2bee3b6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience a clean and modern bathroom design, featuring a spacious vanity with a bright, illuminated mirror, a sleek bathtub with a teal shower curtain, and stylish black accents throughout.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, black faucet, illuminated mirror, bathtub, and teal shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21ad57e7-5eb3-48af-9580-918a7b6666a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9e2c-760a-b5b7-0f85ba6eef51.webp",
      "image_media": {
        "alt_text": "Stainless steel range and microwave above blue subway tile backsplash in a modern kitchen.",
        "public_id": "01a03518-9e2c-760a-b5b7-0f85ba6eef51",
        "storage_key": "property/6767906449167727/01a03518-9e2c-760a-b5b7-0f85ba6eef51.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience the joy of cooking in this beautifully appointed kitchen, featuring a sleek stainless steel range and microwave, complemented by a stylish blue subway tile backsplash.",
      "link": "",
      "alt_text": "Stainless steel range and microwave above blue subway tile backsplash in a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bffd7580-1c01-474b-8995-0b0c0db1876d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9729-725c-abb6-6df7f3c4f5fa.webp",
      "image_media": {
        "alt_text": "Modern open-concept living and dining area with a sleek kitchen.",
        "public_id": "01a03518-9729-725c-abb6-6df7f3c4f5fa",
        "storage_key": "property/6767906449167727/01a03518-9729-725c-abb6-6df7f3c4f5fa.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern open-concept living and dining area, seamlessly flowing into a gourmet kitchen featuring stainless steel appliances and elegant finishes.",
      "link": "",
      "alt_text": "Modern open-concept living and dining area with a sleek kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db1c3520-7978-4504-b4af-b2c8d9aeaea8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8fbf-77e8-bc5d-47a59df4a611.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island, stainless steel appliances, and pendant lighting.",
        "public_id": "01a03518-8fbf-77e8-bc5d-47a59df4a611",
        "storage_key": "property/6767906449167727/01a03518-8fbf-77e8-bc5d-47a59df4a611.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring white cabinetry, a subway tile backsplash, and a spacious island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with a large island, stainless steel appliances, and pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e831d673-3855-4e61-9546-35a2dfe7f568",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8bdf-747b-939f-353fed53fe82.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a laundry room with a shelf above",
        "public_id": "01a03518-8bdf-747b-939f-353fed53fe82",
        "storage_key": "property/6767906449167727/01a03518-8bdf-747b-939f-353fed53fe82.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area with a washer and dryer, plus overhead shelving for storage.",
      "link": "",
      "alt_text": "Stackable washer and dryer in a laundry room with a shelf above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dba43247-0dca-4eaf-a1e3-20beaf475fd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-886c-76a2-8888-f9ad0bb42091.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, large illuminated mirror, bathtub with shower curtain, and toilet.",
        "public_id": "01a03518-886c-76a2-8888-f9ad0bb42091",
        "storage_key": "property/6767906449167727/01a03518-886c-76a2-8888-f9ad0bb42091.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with a modern faucet, a large illuminated mirror, a bathtub with a chic shower curtain, and a sleek toilet.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, large illuminated mirror, bathtub with shower curtain, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d30943e-3022-4b8b-82a7-f8161c139199",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-81bf-7298-bf8b-470d38898c95.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-sized bed, walk-in closet, and ensuite bathroom.",
        "public_id": "01a03518-81bf-7298-bf8b-470d38898c95",
        "storage_key": "property/6767906449167727/01a03518-81bf-7298-bf8b-470d38898c95.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish primary bedroom featuring a comfortable king-sized bed, ample closet space, and convenient access to the ensuite bathroom.",
      "link": "",
      "alt_text": "Primary bedroom with a king-sized bed, walk-in closet, and ensuite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b221662-fafa-49ea-8a5b-d81d88832b67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8088-7199-b8e9-ea7c0b76d5ae.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with white couch, leather chairs, and stainless steel appliances.",
        "public_id": "01a03518-8088-7199-b8e9-ea7c0b76d5ae",
        "storage_key": "property/6767906449167727/01a03518-8088-7199-b8e9-ea7c0b76d5ae.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish open-concept living space featuring a comfortable white sofa, sleek leather armchairs, and a fully equipped kitchen with modern appliances. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen with white couch, leather chairs, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b0757e2-0600-4139-93d8-5489e32c9e60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-7e2a-74fd-9491-7f54317ae5d7.webp",
      "image_media": {
        "alt_text": "Green sectional sofa with decorative pillows and a round coffee table in a modern living room with large windows.",
        "public_id": "01a03518-7e2a-74fd-9491-7f54317ae5d7",
        "storage_key": "property/6767906449167727/01a03518-7e2a-74fd-9491-7f54317ae5d7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and stylish living room featuring a plush green sectional sofa, a contemporary round coffee table, and large windows that let in abundant natural light. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Green sectional sofa with decorative pillows and a round coffee table in a modern living room with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c69f244-10c8-4f46-b394-a5ee408d24a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-7764-70f9-8568-bd1654ff8b78.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving and storage boxes.",
        "public_id": "01a03518-7764-70f9-8568-bd1654ff8b78",
        "storage_key": "property/6767906449167727/01a03518-7764-70f9-8568-bd1654ff8b78.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and organized storage solutions, perfect for keeping your belongings tidy.",
      "link": "",
      "alt_text": "Walk-in closet with shelving and storage boxes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35127f44-b8f8-4e34-b613-2776427473a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-711d-70c9-a70e-5af5aa1c4a44.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and entertainment center.",
        "public_id": "01a03518-711d-70c9-a70e-5af5aa1c4a44",
        "storage_key": "property/6767906449167727/01a03518-711d-70c9-a70e-5af5aa1c4a44.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a plush sectional sofa, stylish coffee table, and a modern entertainment center, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54ecb176-ed73-408f-8341-70543382c9c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-700e-76b8-9efb-bc409a8a8a5e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, illuminated mirror, bathtub, and shower.",
        "public_id": "01a03518-700e-76b8-9efb-bc409a8a8a5e",
        "storage_key": "property/6767906449167727/01a03518-700e-76b8-9efb-bc409a8a8a5e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience luxury in our modern bathrooms, featuring sleek vanities, illuminated mirrors, and premium fixtures for a spa-like feel.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, illuminated mirror, bathtub, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_385d42ba-f87f-45da-9078-3b06b408be01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-640c-75fe-8a45-5a79d97b8abe.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen with a green sectional sofa, coffee table, and modern kitchen.",
        "public_id": "01a03518-640c-75fe-8a45-5a79d97b8abe",
        "storage_key": "property/6767906449167727/01a03518-640c-75fe-8a45-5a79d97b8abe.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and kitchen area featuring a plush green sectional sofa, stylish coffee table, and a fully equipped modern kitchen, perfect for comfortable living.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen with a green sectional sofa, coffee table, and modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c815dbf-9064-4ab1-a9e8-9edb41d22991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-631c-7189-b5ce-3e058c3ea512.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and bed, large windows, and an adjoining room.",
        "public_id": "01a03518-631c-7189-b5ce-3e058c3ea512",
        "storage_key": "property/6767906449167727/01a03518-631c-7189-b5ce-3e058c3ea512.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Chic bedroom with a large bed, a stylish dresser, and a mirror. Enjoy natural light from the expansive windows.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and bed, large windows, and an adjoining room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd4b6eca-8466-4ee6-8808-8aafee164206",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-5fbb-740d-86b8-4db56068a375.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, white bedding, and a ceiling fan.",
        "public_id": "01a03518-5fbb-740d-86b8-4db56068a375",
        "storage_key": "property/6767906449167727/01a03518-5fbb-740d-86b8-4db56068a375.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A beautifully decorated bedroom featuring a comfortable queen-size bed, elegant curtains, and modern artwork.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, white bedding, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c84e3f5f-64f7-411c-b1bb-3203e21a2890",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-5427-73e8-b6cc-d7acd4df8eb2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and open living area.",
        "public_id": "01a03518-5427-73e8-b6cc-d7acd4df8eb2",
        "storage_key": "property/6767906449167727/01a03518-5427-73e8-b6cc-d7acd4df8eb2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Discover the sleek, modern kitchen featuring stainless steel appliances, ample cabinet space, and a spacious island perfect for casual dining. Enjoy the open-concept design flowing into the living area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and open living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9dd5130-e231-4211-ba73-dacad72d9e6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-4ce2-72ab-a8f6-652ffafa7eb1.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and seating area with blue chairs and tables in front of apartment buildings.",
        "public_id": "01a03518-4ce2-72ab-a8f6-652ffafa7eb1",
        "storage_key": "property/6767906449167727/01a03518-4ce2-72ab-a8f6-652ffafa7eb1.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our modern grilling stations and comfortable seating areas, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor grilling and seating area with blue chairs and tables in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6099fb88-66a1-4a7d-843c-8465ec9c5953",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-56ad-727e-a4ff-0774aa43e9b1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and a teal subway tile backsplash.",
        "public_id": "01a03518-56ad-727e-a4ff-0774aa43e9b1",
        "storage_key": "property/6767906449167727/01a03518-56ad-727e-a4ff-0774aa43e9b1.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek light wood cabinetry, a stainless steel microwave and oven, and a stylish teal tile backsplash. Perfect for culinary creations.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and a teal subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73cab574-72e7-47d5-81c4-1b18db7fe11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-433b-772c-b084-fc4fd9a2001b.webp",
      "image_media": {
        "alt_text": "Courtyard with fire pit and seating area.",
        "public_id": "01a03518-433b-772c-b084-fc4fd9a2001b",
        "storage_key": "property/6767906449167727/01a03518-433b-772c-b084-fc4fd9a2001b.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful courtyard, featuring a cozy fire pit and comfortable seating, perfect for evening gatherings.",
      "link": "",
      "alt_text": "Courtyard with fire pit and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9480694c-db99-4f15-a6a5-556cc4fdc6a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-490a-7108-9a6b-1eea3bb78a36.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a03518-490a-7108-9a6b-1eea3bb78a36",
        "storage_key": "property/6767906449167727/01a03518-490a-7108-9a6b-1eea3bb78a36.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek light wood cabinetry, top-of-the-line stainless steel appliances, and a spacious island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2e7e339-996c-41d4-8ee3-f798cf125f58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-47a6-70bf-bbc9-115cc0de1adf.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with light wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a03518-47a6-70bf-bbc9-115cc0de1adf",
        "storage_key": "property/6767906449167727/01a03518-47a6-70bf-bbc9-115cc0de1adf.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring sleek light wood cabinetry, modern stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern apartment kitchen with light wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c1d234d-3169-4c16-9200-29b2458137cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-3a95-728f-b659-7104e86b510a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, and a large island with seating.",
        "public_id": "01a03518-3a95-728f-b659-7104e86b510a",
        "storage_key": "property/6767906449167727/01a03518-3a95-728f-b659-7104e86b510a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience the convenience of a fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a stylish backsplash. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, and a large island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1758264a-762e-442a-9296-d0ea95088106",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-2ef6-72bb-a5dd-8d2baec54aff.webp",
      "image_media": {
        "alt_text": "A furnished balcony overlooks a street with parked cars and apartment buildings.",
        "public_id": "01a03518-2ef6-72bb-a5dd-8d2baec54aff",
        "storage_key": "property/6767906449167727/01a03518-2ef6-72bb-a5dd-8d2baec54aff.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxations on this private, furnished balcony overlooking the neighborhood street. Ideal for soaking in the atmosphere.",
      "link": "",
      "alt_text": "A furnished balcony overlooks a street with parked cars and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_415269d0-cbff-491f-9c31-48f2573c9fa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-3239-7465-a41f-7886eeced0a9.webp",
      "image_media": {
        "alt_text": "Chairs and side table on apartment balcony with view of building exterior.",
        "public_id": "01a03518-3239-7465-a41f-7886eeced0a9",
        "storage_key": "property/6767906449167727/01a03518-3239-7465-a41f-7886eeced0a9.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Relax on your private balcony, furnished with comfortable seating and a stylish side table, overlooking the vibrant community.",
      "link": "",
      "alt_text": "Chairs and side table on apartment balcony with view of building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5cb6c932-3ae9-461d-903b-5bfd57ebe0cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-22b0-7318-b1d0-45d88e076f2e.webp",
      "image_media": {
        "alt_text": "Balcony with seating and view of modern apartment buildings.",
        "public_id": "01a03518-22b0-7318-b1d0-45d88e076f2e",
        "storage_key": "property/6767906449167727/01a03518-22b0-7318-b1d0-45d88e076f2e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on your private balcony, with a stunning view of the surrounding modern architecture.",
      "link": "",
      "alt_text": "Balcony with seating and view of modern apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b5465ec-9787-46cb-af04-7531ac75f7c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-21eb-7697-af1d-58b04f04a0bb.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building entrance with a porch and outdoor seating.",
        "public_id": "01a03518-21eb-7697-af1d-58b04f04a0bb",
        "storage_key": "property/6767906449167727/01a03518-21eb-7697-af1d-58b04f04a0bb.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Step onto your private porch and enjoy the view of the bustling street and modern apartment buildings. Perfect for a morning coffee or evening relaxation.",
      "link": "",
      "alt_text": "Exterior view of an apartment building entrance with a porch and outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f859d037-ed4e-40bf-8405-04fa68d1781f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-16ba-763c-9f88-24742206b705.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with blue adirondack chairs and a fire pit in front of an apartment building.",
        "public_id": "01a03518-16ba-763c-9f88-24742206b705",
        "storage_key": "property/6767906449167727/01a03518-16ba-763c-9f88-24742206b705.webp",
        "width": 1980,
        "height": 1320
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with comfortable seating and a modern fire pit, perfect for enjoying cool evenings.",
      "link": "",
      "alt_text": "Outdoor patio area with blue adirondack chairs and a fire pit in front of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff5c7a36-edbc-4b35-ac3d-b630a4ace7ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-1081-7789-8657-c9560b8e88ea.webp",
      "image_media": {
        "alt_text": "Courtyard with fountain and seating areas at a modern apartment building.",
        "public_id": "01a03518-1081-7789-8657-c9560b8e88ea",
        "storage_key": "property/6767906449167727/01a03518-1081-7789-8657-c9560b8e88ea.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy relaxing by the central fountain in our beautiful courtyard. A perfect spot to unwind.",
      "link": "",
      "alt_text": "Courtyard with fountain and seating areas at a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03bece0b-eaf9-4f2f-8121-6a6217871761",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-0539-732b-b288-bbc96975f3d9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
        "public_id": "01a03518-0539-732b-b288-bbc96975f3d9",
        "storage_key": "property/6767906449167727/01a03518-0539-732b-b288-bbc96975f3d9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Dive into relaxation at our stunning resort-style swimming pool. Enjoy ample lounge seating, private cabanas, and the beautiful surrounding apartment community.",
      "link": "",
      "alt_text": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b8458652-ef7d-4a7c-8808-eeadc30c57c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-f9fc-779e-bc1c-cc20f40fbb23.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and palm trees.",
        "public_id": "01a03517-f9fc-779e-bc1c-cc20f40fbb23",
        "storage_key": "property/6767906449167727/01a03517-f9fc-779e-bc1c-cc20f40fbb23.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy the outdoors at this stylish apartment complex, featuring balconies and lush landscaping.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af9eb790-7f6a-434e-8a2b-86562d85d4ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-f5b2-76b0-a768-f2bf559e4aed.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a bar area next to apartment buildings.",
        "public_id": "01a03517-f5b2-76b0-a768-f2bf559e4aed",
        "storage_key": "property/6767906449167727/01a03517-f5b2-76b0-a768-f2bf559e4aed.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with comfortable lounge chairs and a stylish bar area, perfect for relaxing and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a bar area next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5be78064-f6c0-419b-b588-05051ffc9849",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-e242-7066-9f45-10e929aeaf21.webp",
      "image_media": {
        "alt_text": "Billiards table and shuffleboard in a modern lounge area with a bar and seating.",
        "public_id": "01a03517-e242-7066-9f45-10e929aeaf21",
        "storage_key": "property/6767906449167727/01a03517-e242-7066-9f45-10e929aeaf21.webp",
        "width": 1337,
        "height": 684
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our resident lounge featuring a billiards table, shuffleboard, and a stylish bar area perfect for socializing.",
      "link": "",
      "alt_text": "Billiards table and shuffleboard in a modern lounge area with a bar and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a466c3e-3aef-46e2-9ffc-3b9e4c3e1a16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-d8ec-7538-9fee-00045801a086.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs at a modern apartment complex",
        "public_id": "01a03517-d8ec-7538-9fee-00045801a086",
        "storage_key": "property/6767906449167727/01a03517-d8ec-7538-9fee-00045801a086.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling pool or relax on a lounge chair at this beautiful apartment community.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs at a modern apartment complex",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b63c86fe-4a78-4e30-8b4f-6f88cef64e82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-d3e9-752a-b12a-56cfca5e8535.webp",
      "image_media": {
        "alt_text": "Fitness center with free weights, weight machines, and cardio equipment.",
        "public_id": "01a03517-d3e9-752a-b12a-56cfca5e8535",
        "storage_key": "property/6767906449167727/01a03517-d3e9-752a-b12a-56cfca5e8535.webp",
        "width": 1168,
        "height": 984
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a full range of strength training and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with free weights, weight machines, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_114df562-d0b1-46ff-8e03-7ed2b1774be1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-64e4-722e-9c20-80ef11d92e1c.webp",
      "image_media": {
        "alt_text": "Modern stainless steel kitchen with a red espresso machine and subway tile backsplash.",
        "public_id": "01a03517-64e4-722e-9c20-80ef11d92e1c",
        "storage_key": "property/6767906449167727/01a03517-64e4-722e-9c20-80ef11d92e1c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen, featuring stainless steel appliances, a sleek subway tile backsplash, and ample counter space for meal preparation.",
      "link": "",
      "alt_text": "Modern stainless steel kitchen with a red espresso machine and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9865cb35-99c7-483b-884a-3f345d920fe0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-644b-71e8-b21e-27081d56ccfc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and light wood cabinets.",
        "public_id": "01a03517-644b-71e8-b21e-27081d56ccfc",
        "storage_key": "property/6767906449167727/01a03517-644b-71e8-b21e-27081d56ccfc.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Expansive kitchen featuring a large island with bar seating, stainless steel appliances, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3aa76680-1854-4b8e-a820-2af04a0366f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-5c42-77e9-8663-8e1d979d9cba.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, backlit mirror, and a bathtub with a teal shower curtain.",
        "public_id": "01a03517-5c42-77e9-8663-8e1d979d9cba",
        "storage_key": "property/6767906449167727/01a03517-5c42-77e9-8663-8e1d979d9cba.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience the elegance of this modern bathroom, featuring a sleek white vanity, a large backlit mirror, and a pristine bathtub with a soothing teal shower curtain. A perfect blend of style and function.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, backlit mirror, and a bathtub with a teal shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a9e321a-ec5d-4f9a-8022-6fd29f169223",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-5daa-77a4-bb41-3a69888819d0.webp",
      "image_media": {
        "alt_text": "Home office with a stair stepper, yoga ball, dumbbells, and a desk with a computer.",
        "public_id": "01a03517-5daa-77a4-bb41-3a69888819d0",
        "storage_key": "property/6767906449167727/01a03517-5daa-77a4-bb41-3a69888819d0.webp",
        "width": 1536,
        "height": 1021
      },
      "title": "Apartment",
      "description": "Create your ideal workspace or home gym in this versatile room, perfect for productivity and wellness.",
      "link": "",
      "alt_text": "Home office with a stair stepper, yoga ball, dumbbells, and a desk with a computer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7bab65e-9df1-4c82-8914-ec7d03c3e7a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-5c31-7480-ad83-930014757da7.webp",
      "image_media": {
        "alt_text": "Dining area and living room with large windows and a balcony door.",
        "public_id": "01a03517-5c31-7480-ad83-930014757da7",
        "storage_key": "property/6767906449167727/01a03517-5c31-7480-ad83-930014757da7.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Bright and airy living and dining space with large windows and balcony access, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Dining area and living room with large windows and a balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9e9794e3-3701-4cee-8d86-a136280c20e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-3089-758f-b4f7-ef7376e8a8e7.webp",
      "image_media": {
        "alt_text": "Balcony with outdoor seating and a palm tree, with apartment buildings and parked cars in the background.",
        "public_id": "01a03517-3089-758f-b4f7-ef7376e8a8e7",
        "storage_key": "property/6767906449167727/01a03517-3089-758f-b4f7-ef7376e8a8e7.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with comfortable seating and scenic views of the surrounding community.",
      "link": "",
      "alt_text": "Balcony with outdoor seating and a palm tree, with apartment buildings and parked cars in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_266fd087-7322-4a3b-ab56-da3544ab68b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-32e7-7618-b2cb-2b6edde22180.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with seating and umbrellas",
        "public_id": "01a03517-32e7-7618-b2cb-2b6edde22180",
        "storage_key": "property/6767906449167727/01a03517-32e7-7618-b2cb-2b6edde22180.webp",
        "width": 1536,
        "height": 864
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and entertaining at the community grilling station with ample seating and shade.",
      "link": "",
      "alt_text": "Outdoor grilling area with seating and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96875b89-239f-4362-a8bb-fd057f77bd39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-2ff2-7158-87d2-1dd6d6f7950f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, ample cabinetry, and a large island with seating.",
        "public_id": "01a03517-2ff2-7158-87d2-1dd6d6f7950f",
        "storage_key": "property/6767906449167727/01a03517-2ff2-7158-87d2-1dd6d6f7950f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Discover a stylish and functional kitchen featuring sleek stainless steel appliances, light wood cabinetry, a subway tile backsplash, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, ample cabinetry, and a large island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d46e9d8-10df-493a-adcc-1d5645f79f21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-2e98-778d-bc9a-17c4f10e8c34.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building entrance with a patio chair and a palm tree in front.",
        "public_id": "01a03517-2e98-778d-bc9a-17c4f10e8c34",
        "storage_key": "property/6767906449167727/01a03517-2e98-778d-bc9a-17c4f10e8c34.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Enjoy the fresh air from your private patio at this apartment building, featuring modern architecture and lush landscaping.",
      "link": "",
      "alt_text": "Exterior view of an apartment building entrance with a patio chair and a palm tree in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1d9a6a9-e467-4d9b-8bbb-0b0cb21d8432",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-22c0-72cf-9310-5a5410f6f211.webp",
      "image_media": {
        "alt_text": "Apartment courtyard with a fountain and seating areas.",
        "public_id": "01a03517-22c0-72cf-9310-5a5410f6f211",
        "storage_key": "property/6767906449167727/01a03517-22c0-72cf-9310-5a5410f6f211.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy the serene courtyard featuring a beautiful fountain and comfortable seating areas. A perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Apartment courtyard with a fountain and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae9096e0-45fe-4133-bc15-0d4d49eeb060",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-2309-7621-94e3-dadca766f935.webp",
      "image_media": {
        "alt_text": "Balcony with seating and view of apartment building exterior",
        "public_id": "01a03517-2309-7621-94e3-dadca766f935",
        "storage_key": "property/6767906449167727/01a03517-2309-7621-94e3-dadca766f935.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxations on this spacious balcony, offering a scenic view of the surrounding modern architecture.",
      "link": "",
      "alt_text": "Balcony with seating and view of apartment building exterior",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19d32ddb-e09b-4567-9474-8d27b1ec6d34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-2136-740f-a5c0-5ff76cac50b7.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with blue Adirondack chairs and a fire pit.",
        "public_id": "01a03517-2136-740f-a5c0-5ff76cac50b7",
        "storage_key": "property/6767906449167727/01a03517-2136-740f-a5c0-5ff76cac50b7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax in the inviting outdoor seating area, complete with comfortable Adirondack chairs and a modern fire pit, perfect for social gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with blue Adirondack chairs and a fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5cc3d03c-ddf6-4c06-9db7-06906d86ec39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-2492-730a-b024-4d698e25e5f8.webp",
      "image_media": {
        "alt_text": "Courtyard with fire pit and seating area",
        "public_id": "01a03517-2492-730a-b024-4d698e25e5f8",
        "storage_key": "property/6767906449167727/01a03517-2492-730a-b024-4d698e25e5f8.webp",
        "width": 1536,
        "height": 864
      },
      "title": "Community",
      "description": "Relax and unwind in the communal courtyard, featuring a cozy fire pit and comfortable seating.",
      "link": "",
      "alt_text": "Courtyard with fire pit and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c2bfb32-350b-4d31-8385-a9d82b91f713",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-21bd-7704-bfdf-d831096d16f7.webp",
      "image_media": {
        "alt_text": "Gated dog park with green turf, trees, and benches.",
        "public_id": "01a03517-21bd-7704-bfdf-d831096d16f7",
        "storage_key": "property/6767906449167727/01a03517-21bd-7704-bfdf-d831096d16f7.webp",
        "width": 1536,
        "height": 1026
      },
      "title": "Community",
      "description": "Enjoy our spacious, gated dog park with plenty of room for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Gated dog park with green turf, trees, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d6de1f8-d670-42ad-807e-95d6905e138e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-135b-73ff-a31e-3af9f1109a7e.webp",
      "image_media": {
        "alt_text": "Courtyard swimming pool with lounge chairs and cabanas.",
        "public_id": "01a03517-135b-73ff-a31e-3af9f1109a7e",
        "storage_key": "property/6767906449167727/01a03517-135b-73ff-a31e-3af9f1109a7e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by the stunning courtyard swimming pool, complete with comfortable lounge chairs and private cabanas for your enjoyment.",
      "link": "",
      "alt_text": "Courtyard swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b3bdc81-5b6c-4d9f-97d3-ee60646a1bfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-1488-7055-b8cf-90bbd56e61ac.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building balconies and outdoor seating area with blue chairs and palm trees.",
        "public_id": "01a03517-1488-7055-b8cf-90bbd56e61ac",
        "storage_key": "property/6767906449167727/01a03517-1488-7055-b8cf-90bbd56e61ac.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy the outdoors in the comfortable seating area, surrounded by lush greenery and the modern architecture of the building.",
      "link": "",
      "alt_text": "Exterior view of apartment building balconies and outdoor seating area with blue chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c77fe200-d06a-4541-9838-ef4017ffc21c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-13db-7059-baa6-61d910f91e40.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a bar area at a multifamily property.",
        "public_id": "01a03517-13db-7059-baa6-61d910f91e40",
        "storage_key": "property/6767906449167727/01a03517-13db-7059-baa6-61d910f91e40.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool at our community's resort-style pool area, complete with lounge seating and an outdoor bar.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a bar area at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_668c455de6ab512227d78d8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Bern's Steak House",
      "poi_type": "Restaurants",
      "poi_address": "1208 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Opened in 1956, this destination features dry-aged steaks, a huge wine list & flocked wallpaper.",
      "poi_long_description": "Opened in 1956, this destination features dry-aged steaks, a huge wine list & flocked wallpaper.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-7fd9-71af-8477-a7bd42004c81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-7fd9-71af-8477-a7bd42004c81",
        "storage_key": "property/6767906449167727/01a03518-7fd9-71af-8477-a7bd42004c81.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.bernssteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684552119218294820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berns-steak-house",
      "poi_latitude": "27.9316028",
      "poi_longitude": "-82.48285179999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-251-2421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQXHdmfDwogRJFCLuT7eJ6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_38c13aa0565540a83f142a41",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Oxford Exchange",
      "poi_type": "Restaurants",
      "poi_address": "420 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "European-inspired space featuring a restaurant, bookstore, coffeehouse & shop with decor & gifts.",
      "poi_long_description": "European-inspired space featuring a restaurant, bookstore, coffeehouse & shop with decor & gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-d744-71ff-93bc-acb208c3fa98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-d744-71ff-93bc-acb208c3fa98",
        "storage_key": "property/6767906449167727/01a03515-d744-71ff-93bc-acb208c3fa98.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://oxfordexchange.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11520336291559321740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-exchange",
      "poi_latitude": "27.9449261",
      "poi_longitude": "-82.4646338",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-253-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11hsiYXEwogRjDBv39F04J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_f60e1c23d97c300c536cdf04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Ulele",
      "poi_type": "Restaurants",
      "poi_address": "1810 N Highland Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Rustic-chic site for native Floridian fare, with barbacoa grilling & house-brewed beers.",
      "poi_long_description": "Rustic-chic site for native Floridian fare, with barbacoa grilling & house-brewed beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-d7ca-763f-b509-746eb541f1ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-d7ca-763f-b509-746eb541f1ff",
        "storage_key": "property/6767906449167727/01a03515-d7ca-763f-b509-746eb541f1ff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ulele.com/?utm_source=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=7024264887899776259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulele",
      "poi_latitude": "27.9599384",
      "poi_longitude": "-82.4628003",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-999-4952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Vyq7WTEwogRA-WDC7Mze2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_5fb9b4950b2e8b1873319e4a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Oak & Ola",
      "poi_type": "Restaurants",
      "poi_address": "1910 N Ola Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Hip restaurant with a roof terrace & regular live music crafting cocktails, pizzas & refined mains.",
      "poi_long_description": "Hip restaurant with a roof terrace & regular live music crafting cocktails, pizzas & refined mains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-80ab-7641-b926-a5c39a7b00e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-80ab-7641-b926-a5c39a7b00e7",
        "storage_key": "property/6767906449167727/01a03518-80ab-7641-b926-a5c39a7b00e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.oakandola.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15067581101493658679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak--ola",
      "poi_latitude": "27.9608352",
      "poi_longitude": "-82.4643177",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-773-1901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdsuKwDFwogRNyTrKi7NGtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_017e49dd39e450bb11da30d2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Steelbach Southern Chophouse & Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1902 N Ola Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Riverfront Southern grill restaurant with al fresco tables in a restored brick streetcar warehouse.",
      "poi_long_description": "Riverfront Southern grill restaurant with al fresco tables in a restored brick streetcar warehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8373-741d-a341-0509fbb0e33b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8373-741d-a341-0509fbb0e33b",
        "storage_key": "property/6767906449167727/01a03518-8373-741d-a341-0509fbb0e33b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.steelbach.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17450942912578951509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steelbach-southern-chophouse--steakhouse",
      "poi_latitude": "27.9609067",
      "poi_longitude": "-82.46373129999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-535-4974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_430WTEwogRVZnjsx40LvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_e3086f76f85ee64870103bbf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Buddy Brew Coffee",
      "poi_type": "Restaurants",
      "poi_address": "Buddy Brew Coffee - Armature Works, 1910 N Ola Ave #8, Tampa, FL 33602, USA",
      "poi_short_description": "Artisan coffee bar serving a variety of caffeinated drinks, plus baked goods, sandwiches and teas, in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-848d-74ce-b997-6aabb88cf4f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-848d-74ce-b997-6aabb88cf4f6",
        "storage_key": "property/6767906449167727/01a03518-848d-74ce-b997-6aabb88cf4f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://buddybrewcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12547665554429705043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buddy-brew-coffee",
      "poi_latitude": "27.9611064",
      "poi_longitude": "-82.4640636",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-258-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b9f9-76db-8c97-4553997bf4f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-b9f9-76db-8c97-4553997bf4f3",
        "storage_key": "property/6767906449167727/01a03518-b9f9-76db-8c97-4553997bf4f3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJEcNjfPvFwogRU_svZFdDIq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_51d70e99164e902f997070ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "On Swann",
      "poi_type": "Restaurants",
      "poi_address": "1501 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Seasonal New American cuisine prepared in an open-concept kitchen in a chic, lofty eatery.",
      "poi_long_description": "Seasonal New American cuisine prepared in an open-concept kitchen in a chic, lofty eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-803e-75da-b8ef-33c8220b0aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-803e-75da-b8ef-33c8220b0aef",
        "storage_key": "property/6767906449167727/01a03518-803e-75da-b8ef-33c8220b0aef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://onswann.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11938981105801394242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-swann",
      "poi_latitude": "27.9374672",
      "poi_longitude": "-82.4749343",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-251-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5crCip3EwogRQnhkbw_Ir6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_742dd2d58cc9127aa0c35714",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Meat Market Steakhouse Tampa",
      "poi_type": "Restaurants",
      "poi_address": "1606 W Snow Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Stunning steakhouse featuring a Miami Beach vibe, seafood, sushi and craft cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-89d1-77cd-a5ce-0f7f157b825f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-89d1-77cd-a5ce-0f7f157b825f",
        "storage_key": "property/6767906449167727/01a03518-89d1-77cd-a5ce-0f7f157b825f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.meatmarket.net/location/meat-market-tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10778224991567861108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meat-market-steakhouse-tampa",
      "poi_latitude": "27.935898",
      "poi_longitude": "-82.47608149999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-280-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwli6xvDwogRdNWjO4byk5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_7e1912a533edd9bd09537b85",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Chanta",
      "poi_type": "Restaurants",
      "poi_address": "113 S Hyde Park Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Mediterranean & Eastern European specialties are crafted in this cozy spot offering outdoor seating.",
      "poi_long_description": "Mediterranean & Eastern European specialties are crafted in this cozy spot offering outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-7fc8-7337-b070-034d674cbb07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-7fc8-7337-b070-034d674cbb07",
        "storage_key": "property/6767906449167727/01a03518-7fc8-7337-b070-034d674cbb07.webp",
        "width": 827,
        "height": 609
      },
      "poi_business_url": "http://www.chantarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762999422959405172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chanta",
      "poi_latitude": "27.9450461",
      "poi_longitude": "-82.4640534",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-605-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJocemZXrFwogRdMhGBnFJ-k8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_1923132c2fccc4d9c7e98392",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Elevage SoHo Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1207 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Upscale all-day restaurant serving creative renditions of American classics in the Epicurean Hotel.",
      "poi_long_description": "Upscale all-day restaurant serving creative renditions of American classics in the Epicurean Hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-863c-7626-9e3e-83adc3af721d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-863c-7626-9e3e-83adc3af721d",
        "storage_key": "property/6767906449167727/01a03518-863c-7626-9e3e-83adc3af721d.webp",
        "width": 1280,
        "height": 876
      },
      "poi_business_url": "http://elevagerestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4746901042356929338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elevage-soho-kitchen--bar",
      "poi_latitude": "27.9305556",
      "poi_longitude": "-82.4833333",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-999-8771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE50sgWfDwogROsOdDVlh4EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_bddef088a549cb5ea8f75b71",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Edison: Food+Drink Lab",
      "poi_type": "Restaurants",
      "poi_address": "912 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "This industrial gastropub sells inventive American plates inspired by the chef's experiments.",
      "poi_long_description": "This industrial gastropub sells inventive American plates inspired by the chef's experiments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-84a4-76b8-8722-23766b9d1881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-84a4-76b8-8722-23766b9d1881",
        "storage_key": "property/6767906449167727/01a03518-84a4-76b8-8722-23766b9d1881.webp",
        "width": 1280,
        "height": 922
      },
      "poi_business_url": "http://edison-tampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9779635231681102435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edison-fooddrink-lab",
      "poi_latitude": "27.9444817",
      "poi_longitude": "-82.4694404",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-254-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ894Jh4TEwogRY0I_sW0-uIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_66c6f83b133bb2107db0afda",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Mise en Place",
      "poi_type": "Restaurants",
      "poi_address": "1229 E 8th Ave, Tampa, FL 33605, USA",
      "poi_short_description": "Chef Marty Blitz presents a New American menu featuring creative plates in a refined space.",
      "poi_long_description": "Chef Marty Blitz presents a New American menu featuring creative plates in a refined space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-805a-761b-bde0-9ff58467cf00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-805a-761b-bde0-9ff58467cf00",
        "storage_key": "property/6767906449167727/01a03518-805a-761b-bde0-9ff58467cf00.webp",
        "width": 960,
        "height": 1200
      },
      "poi_business_url": "http://www.miseonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18007673849555973262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mise-en-place",
      "poi_latitude": "27.9608211",
      "poi_longitude": "-82.4457506",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 813-254-5373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08ZCkIXEwogRjvTfGfUb6Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_d45a717238030512366277eb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "The Pearl Tampa",
      "poi_type": "Restaurants",
      "poi_address": "823 Water St C100, Tampa, FL 33602, USA",
      "poi_short_description": "Casual restaurant and tavern for seafood, cocktails and oysters, with many dishes featuring Southern influences.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-86e3-71dc-8bb4-9699d7d81595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-86e3-71dc-8bb4-9699d7d81595",
        "storage_key": "property/6767906449167727/01a03518-86e3-71dc-8bb4-9699d7d81595.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://thepearlrestaurant.com/locations-menus/tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5355934940250009208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pearl-tampa",
      "poi_latitude": "27.9433114",
      "poi_longitude": "-82.4500879",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-709-7776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4AtxNfFwogReG60gXMaVEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ea26c51e01fa237dfe3efa7f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Rocca",
      "poi_type": "Restaurants",
      "poi_address": "323 W Palm Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Elevated Italian eatery with a pasta focus, plus mozzarella made tableside & a big wine list.",
      "poi_long_description": "Elevated Italian eatery with a pasta focus, plus mozzarella made tableside & a big wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-89ca-71b2-a8ce-33cb0127e836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-89ca-71b2-a8ce-33cb0127e836",
        "storage_key": "property/6767906449167727/01a03518-89ca-71b2-a8ce-33cb0127e836.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://roccatampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11969414653190066132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocca",
      "poi_latitude": "27.9624349",
      "poi_longitude": "-82.465183",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-906-5445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1WZIXhjFwogR1M-_3DXnG6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_9dbf7e4024785f1444bc397c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Columbia Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2117 E 7th Ave, Tampa, FL 33605, USA",
      "poi_short_description": "Traditional Spanish restaurant, a branch of a long-standing local chain dating back to 1905.",
      "poi_long_description": "Traditional Spanish restaurant, a branch of a long-standing local chain dating back to 1905.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-d734-7456-b617-e814c051294e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-d734-7456-b617-e814c051294e",
        "storage_key": "property/6767906449167727/01a03515-d734-7456-b617-e814c051294e.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "http://www.columbiarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4511489481196170245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-restaurant",
      "poi_latitude": "27.9599924",
      "poi_longitude": "-82.4351423",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-248-4961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8e7TVLEwogRBeybvscHnD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "ec_c2456883ba321658a90ade97",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Hyde Park Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "1602 W Snow Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Stylish open-air complex with higher-end retailers, restaurants & bars, plus a movie theater.",
      "poi_long_description": "Stylish open-air complex with higher-end retailers, restaurants & bars, plus a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-d885-70f9-a011-c48c23099589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-d885-70f9-a011-c48c23099589",
        "storage_key": "property/6767906449167727/01a03515-d885-70f9-a011-c48c23099589.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://hydeparkvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7521361268052889209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyde-park-village",
      "poi_latitude": "27.93665",
      "poi_longitude": "-82.4759751",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-251-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06bb-70da-bd04-8bb3ab556793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06bb-70da-bd04-8bb3ab556793",
        "storage_key": "property/6767906449167727/01a03516-06bb-70da-bd04-8bb3ab556793.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQZRp15bDwogReY6sMTk-YWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0a2053a300b359c947f0ad2e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Publix Super Market on Bayshore",
      "poi_type": "Shopping & Retail",
      "poi_address": "243 Bayshore Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8cb7-73c0-a4f6-ce128595905f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8cb7-73c0-a4f6-ce128595905f",
        "storage_key": "property/6767906449167727/01a03518-8cb7-73c0-a4f6-ce128595905f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=628&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=7715569998516166893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-on-bayshore",
      "poi_latitude": "27.9422049",
      "poi_longitude": "-82.46053169999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-251-1173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06b1-719b-80a8-4f5a169bf5b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06b1-719b-80a8-4f5a169bf5b2",
        "storage_key": "property/6767906449167727/01a03516-06b1-719b-80a8-4f5a169bf5b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1anFFY7EwogR7aA36Qg2E2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_b53507ff8949ca09e4b9bba7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8fcd-7464-a3c2-e8647938199d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8fcd-7464-a3c2-e8647938199d",
        "storage_key": "property/6767906449167727/01a03518-8fcd-7464-a3c2-e8647938199d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/tampa/2100-w-swann-ave/fn41",
      "poi_directions_map_url": "https://maps.google.com/?cid=9532165208441620976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "27.93611",
      "poi_longitude": "-82.48151",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06b1-719b-80a8-4f5a169bf5b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06b1-719b-80a8-4f5a169bf5b2",
        "storage_key": "property/6767906449167727/01a03516-06b1-719b-80a8-4f5a169bf5b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZGNUwDDwogR8AmA5cANSYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_93bc9ffac643da463140d638",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "611 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8fdf-747a-a2dd-76449fe5b781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8fdf-747a-a2dd-76449fe5b781",
        "storage_key": "property/6767906449167727/01a03518-8fdf-747a-a2dd-76449fe5b781.webp",
        "width": 1280,
        "height": 778
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tampa-fl-pharmacies/611-s-howard-ave-tampa-fl-33606/storeid=3930?WT.mc_id=LS_GOOGLE_FS_3930",
      "poi_directions_map_url": "https://maps.google.com/?cid=11377510792502676422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "27.9377096",
      "poi_longitude": "-82.4836397",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-259-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6Ady2XDwogRxotL_8gJ5Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_57a9ef5616e6a0ae4e534e95",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "315 W Platt St, Tampa, FL 33606, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8b5a-7730-8fb0-6f0da45009af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8b5a-7730-8fb0-6f0da45009af",
        "storage_key": "property/6767906449167727/01a03518-8b5a-7730-8fb0-6f0da45009af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-315+w+platt+st-tampa-fl-33606/id=5451",
      "poi_directions_map_url": "https://maps.google.com/?cid=15347163305654164579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "27.9420033",
      "poi_longitude": "-82.4635558",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-251-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8YV6Y_EwogRYxxtt7YT_NQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_48e20b4ea5ab13a5488ae632",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Metro Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8f23-745f-a11c-e693919161cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8f23-745f-a11c-e693919161cb",
        "storage_key": "property/6767906449167727/01a03518-8f23-745f-a11c-e693919161cb.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17661552311799788824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-market",
      "poi_latitude": "27.9443668",
      "poi_longitude": "-82.4689195",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-466-5153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b9f8-73c9-877d-72d7b4d0da47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-b9f8-73c9-877d-72d7b4d0da47",
        "storage_key": "property/6767906449167727/01a03518-b9f8-73c9-877d-72d7b4d0da47.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJA7o8YoTEwogRGDXOrkBwGvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_52eadb45d8174e0d564b9464",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3740 Midtown Dr, Tampa, FL 33607, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-dc6c-739b-bb06-bb45e2f4ed39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-dc6c-739b-bb06-bb45e2f4ed39",
        "storage_key": "property/6767906449167727/01a03515-dc6c-739b-bb06-bb45e2f4ed39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/midtowntampa?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=7412796578828606656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "27.9528728",
      "poi_longitude": "-82.5048529",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-323-9466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06b1-719b-80a8-4f5a169bf5b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06b1-719b-80a8-4f5a169bf5b2",
        "storage_key": "property/6767906449167727/01a03516-06b1-719b-80a8-4f5a169bf5b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz2aQZfDwogRwFxPuTaL32Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_30e5ee91cc9580da1637b452",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "The University of Tampa",
      "poi_type": "Education",
      "poi_address": "401 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-df92-74b1-86ee-4e9872d09403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-df92-74b1-86ee-4e9872d09403",
        "storage_key": "property/6767906449167727/01a03515-df92-74b1-86ee-4e9872d09403.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.ut.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5456992893672379865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-tampa",
      "poi_latitude": "27.9468757",
      "poi_longitude": "-82.46722659999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-253-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90AFeYbEwogR2VUs2R8iu0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_21daeab008ab56b092a89372",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa Preparatory School",
      "poi_type": "Education",
      "poi_address": "727 W Cass St, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-8f72-7112-bdc9-b441dee30ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-8f72-7112-bdc9-b441dee30ed3",
        "storage_key": "property/6767906449167727/01a03518-8f72-7112-bdc9-b441dee30ed3.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "https://tampaprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13698294515783081250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-preparatory-school",
      "poi_latitude": "27.95152",
      "poi_longitude": "-82.4677325",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-251-8481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjzUioYfEwogRIp3uEUkeGr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_069f8c30ffa710c3fbd436fa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Wilson Middle School",
      "poi_type": "Education",
      "poi_address": "1005 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-928a-7618-a7ed-1aa5832cb7e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-928a-7618-a7ed-1aa5832cb7e3",
        "storage_key": "property/6767906449167727/01a03518-928a-7618-a7ed-1aa5832cb7e3.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://wilsonms.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5047233007986041845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilson-middle-school",
      "poi_latitude": "27.937595",
      "poi_longitude": "-82.46998719999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-276-5682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJodBp04nFwogR9WOi661fC0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_afef0bcd5d6c26665150b72f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Montessori Children's House of Hyde Park",
      "poi_type": "Education",
      "poi_address": "2416 W Cleveland St, Tampa, FL 33609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-917a-7146-a8e1-b9965382aa3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-917a-7146-a8e1-b9965382aa3d",
        "storage_key": "property/6767906449167727/01a03518-917a-7146-a8e1-b9965382aa3d.webp",
        "width": 1024,
        "height": 765
      },
      "poi_business_url": "https://www.cdstampabay.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001100885191836946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-childrens-house-of-hyde-park",
      "poi_latitude": "27.9431163",
      "poi_longitude": "-82.4847724",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-354-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuVO-u3rDwogREkXUk-HB0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_610e35ca2ee798c6b1a00cc7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Legacy Preparatory Academy, Inc",
      "poi_type": "Education",
      "poi_address": "302 E Linebaugh Ave., Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.legacyprepacademy.org/contactus.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8373616720788088516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-preparatory-academy-inc",
      "poi_latitude": "28.0403138",
      "poi_longitude": "-82.4575947",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 813-253-0053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR0m7jd7GwogRxGbYzwoQNXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e26867e96d7d1cb21e9e9e17",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "St. John the Baptist Greek Orthodox Church",
      "poi_type": "Education",
      "poi_address": "2418 W Swann Ave, Tampa, FL 33609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9372-7159-9854-9643b0a557ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9372-7159-9854-9643b0a557ff",
        "storage_key": "property/6767906449167727/01a03518-9372-7159-9854-9643b0a557ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stjohntpa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16454014107866951187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-john-the-baptist-greek-orthodox-church",
      "poi_latitude": "27.9370238",
      "poi_longitude": "-82.484757",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-876-8830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b9fa-7212-803e-bae803bb2000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-b9fa-7212-803e-bae803bb2000",
        "storage_key": "property/6767906449167727/01a03518-b9fa-7212-803e-bae803bb2000.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-yT4WXDwogRE-6sbKdmWOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "ec_87a30561bf32b493ad36b8d5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "St Joseph Catholic School",
      "poi_type": "Education",
      "poi_address": "2200 N Gomez Ave, Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9638-70dd-90b6-a115c809239c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9638-70dd-90b6-a115c809239c",
        "storage_key": "property/6767906449167727/01a03518-9638-70dd-90b6-a115c809239c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.stjosephtampa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15182522393029633464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-joseph-catholic-school",
      "poi_latitude": "27.9609506",
      "poi_longitude": "-82.49230109999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-879-7720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX65d45vDwogRuOXxDq0ns9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_74eda05871a105027d487e80",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "MacFarlane Park Elementary Magnet School",
      "poi_type": "Education",
      "poi_address": "1721 N Mac Dill Ave, Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-95e3-735c-81ef-9daeedd75662.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-95e3-735c-81ef-9daeedd75662",
        "storage_key": "property/6767906449167727/01a03518-95e3-735c-81ef-9daeedd75662.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://macfarlanepark.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1005567194892849483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macfarlane-park-elementary-magnet-school",
      "poi_latitude": "27.9580653",
      "poi_longitude": "-82.4927647",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-356-1760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb3qn2JTDwogRS9FfOQl-9A0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_16456a6e44ce474accf5f27f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "West Tampa Elementary School",
      "poi_type": "Education",
      "poi_address": "2700 W Cherry St, Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-958d-7568-9a91-0cd3202c20a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-958d-7568-9a91-0cd3202c20a7",
        "storage_key": "property/6767906449167727/01a03518-958d-7568-9a91-0cd3202c20a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://westtampa.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895891999337399055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-tampa-elementary-school",
      "poi_latitude": "27.9612105",
      "poi_longitude": "-82.4875857",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-872-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHzg2bpvDwogRD8OGYwv8NZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a121010ac056e6f7e75ccafe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "H. B. Plant High School",
      "poi_type": "Education",
      "poi_address": "2415 S Himes Ave, Tampa, FL 33629, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9889-70ef-a09c-bf9b263f1932.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9889-70ef-a09c-bf9b263f1932",
        "storage_key": "property/6767906449167727/01a03518-9889-70ef-a09c-bf9b263f1932.webp",
        "width": 1280,
        "height": 900
      },
      "poi_business_url": "https://www.hillsboroughschools.org/plant",
      "poi_directions_map_url": "https://maps.google.com/?cid=1787809284984185336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-b-plant-high-school",
      "poi_latitude": "27.9238864",
      "poi_longitude": "-82.5022195",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-272-3033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQTEGaSDDwogR-KGgjRKTzxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_fb35ea75393d90949c99f37e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa Theatre",
      "poi_type": "Entertainment",
      "poi_address": "711 N Franklin St, Tampa, FL 33602, USA",
      "poi_short_description": "Built in 1926, this ornate movie palace features a Wurlitzer organ plus films, shows & other events.",
      "poi_long_description": "Built in 1926, this ornate movie palace features a Wurlitzer organ plus films, shows & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-97b2-71ba-af31-a089570491d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-97b2-71ba-af31-a089570491d8",
        "storage_key": "property/6767906449167727/01a03518-97b2-71ba-af31-a089570491d8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tampatheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13247868558926946431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-theatre",
      "poi_latitude": "27.9503523",
      "poi_longitude": "-82.4589293",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-274-8286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b9fa-7212-803e-b5140bb7082a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-b9fa-7212-803e-b5140bb7082a",
        "storage_key": "property/6767906449167727/01a03518-b9fa-7212-803e-b5140bb7082a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98cKiInEwogRfyDonUPi2bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_d651885287806fa475299d22",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Straz Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1010 N WC Macinnes Pl, Tampa, FL 33602, USA",
      "poi_short_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_long_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9be9-74ff-8993-62e5da8d2e76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9be9-74ff-8993-62e5da8d2e76",
        "storage_key": "property/6767906449167727/01a03518-9be9-74ff-8993-62e5da8d2e76.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.strazcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331971547108004456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "straz-center-for-the-performing-arts",
      "poi_latitude": "27.9516604",
      "poi_longitude": "-82.4640622",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-229-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJce6XFIjEwogRaNJA6ZKu31c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_77148b04aea46b8137f48a9b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "The Florida Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "701 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_long_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-e22d-741e-865f-62f6dc40ede5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-e22d-741e-865f-62f6dc40ede5",
        "storage_key": "property/6767906449167727/01a03515-e22d-741e-865f-62f6dc40ede5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15088866459868476301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-florida-aquarium",
      "poi_latitude": "27.943972",
      "poi_longitude": "-82.44487470000001",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ae-729f-a1d3-3d770e9897d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ae-729f-a1d3-3d770e9897d9",
        "storage_key": "property/6767906449167727/01a03516-06ae-729f-a1d3-3d770e9897d9.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJCXAq5_DEwogRjTPE2xlsZtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_74100133f0c0fe694a3d805e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Glazer Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "110 W Gasparilla Plaza, Tampa, FL 33602, USA",
      "poi_short_description": "Interactive activities focused on weather, art, communication & more for children under 12.",
      "poi_long_description": "Interactive activities focused on weather, art, communication & more for children under 12.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9951-763a-8621-76f650ec3b39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9951-763a-8621-76f650ec3b39",
        "storage_key": "property/6767906449167727/01a03518-9951-763a-8621-76f650ec3b39.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.glazermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14656511005827888982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glazer-childrens-museum",
      "poi_latitude": "27.949577",
      "poi_longitude": "-82.461494",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-443-3861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ba20-74c9-bfa2-391d5a0541f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-ba20-74c9-bfa2-391d5a0541f5",
        "storage_key": "property/6767906449167727/01a03518-ba20-74c9-bfa2-391d5a0541f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6lKAInEwogRVnf5NBtjZss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ef328d3fd78f96cff8e0173b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "120 W Gasparilla Plaza, Tampa, FL 33602, USA",
      "poi_short_description": "Waterfront space with translucent ceilings & polished stone floors housing modern & classical art.",
      "poi_long_description": "Waterfront space with translucent ceilings & polished stone floors housing modern & classical art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9a04-77cb-a813-3dcb8d4a14a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9a04-77cb-a813-3dcb8d4a14a7",
        "storage_key": "property/6767906449167727/01a03518-9a04-77cb-a813-3dcb8d4a14a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14070563233475260026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-museum-of-art",
      "poi_latitude": "27.9494852",
      "poi_longitude": "-82.4629535",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-274-8130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ba20-74c9-bfa2-391d5a0541f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-ba20-74c9-bfa2-391d5a0541f5",
        "storage_key": "property/6767906449167727/01a03518-ba20-74c9-bfa2-391d5a0541f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6ESWITDwogReu72OLauRMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_9d57ea481e286180e24140b7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Curtis Hixon Waterfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 N Ashley Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Large, grassy park provides fenced-in areas with drinking bowls for pets & free monthly concerts.",
      "poi_long_description": "Large, grassy park provides fenced-in areas with drinking bowls for pets & free monthly concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-ef30-73e8-86c8-28f566c7abae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-ef30-73e8-86c8-28f566c7abae",
        "storage_key": "property/6767906449167727/01a03515-ef30-73e8-86c8-28f566c7abae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=11430125373743884324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curtis-hixon-waterfront-park",
      "poi_latitude": "27.9489169",
      "poi_longitude": "-82.4616494",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-274-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06cd-702c-96f6-61dc88010c94",
        "storage_key": "property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRUlG4nEwogRJOgu0Hf2n54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_48ae462df2a83d9e1e57dd44",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Armature Works",
      "poi_type": "Restaurants",
      "poi_address": "1910 N Ola Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Striking mixed-use event space offering an upscale food court, bar & lounge in lofty, historic digs.",
      "poi_long_description": "Striking mixed-use event space offering an upscale food court, bar & lounge in lofty, historic digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-dc1b-70dc-8f3a-a52020c6ab64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-dc1b-70dc-8f3a-a52020c6ab64",
        "storage_key": "property/6767906449167727/01a03515-dc1b-70dc-8f3a-a52020c6ab64.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://armatureworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15923683446625658433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armature-works",
      "poi_latitude": "27.9609343",
      "poi_longitude": "-82.4642724",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-250-3725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ba-729b-8f29-1b37a51031f9",
        "storage_key": "property/6767906449167727/01a03516-06ba-729b-8f29-1b37a51031f9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWj9iZ_PwogRQebjN7pJ_Nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_8d82ce2a9310afdaeaec77c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Sparkman Wharf",
      "poi_type": "Entertainment",
      "poi_address": "615 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Modern waterfront area featuring hip restaurants & shops, a beer garden & street-food stands.",
      "poi_long_description": "Modern waterfront area featuring hip restaurants & shops, a beer garden & street-food stands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-9d72-72fe-b324-3b194067d473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-9d72-72fe-b324-3b194067d473",
        "storage_key": "property/6767906449167727/01a03518-9d72-72fe-b324-3b194067d473.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sparkmanwharf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298001502316238008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sparkman-wharf",
      "poi_latitude": "27.9433292",
      "poi_longitude": "-82.4476555",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-618-5844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0N73GTFwogRuJTf5jAk5B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "ec_b88232bcb926006bf531aeb4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Benchmark International Arena",
      "poi_type": "Entertainment",
      "poi_address": "401 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Huge, snazzy indoor venue hosting pro hockey & arena-football games, plus concerts & more.",
      "poi_long_description": "Huge, snazzy indoor venue hosting pro hockey & arena-football games, plus concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-e5d2-76ad-bda4-3910d8d5ee89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-e5d2-76ad-bda4-3910d8d5ee89",
        "storage_key": "property/6767906449167727/01a03515-e5d2-76ad-bda4-3910d8d5ee89.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.benchmarkintlarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3143982047536201843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benchmark-international-arena",
      "poi_latitude": "27.9427373",
      "poi_longitude": "-82.4517771",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-301-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSV2_Mo3EwogRc8CZwwOroSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_ef4b4411d562ae0f0947b299",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Tampa General Cir, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-ed69-76c8-b260-4a0ef3cfb897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-ed69-76c8-b260-4a0ef3cfb897",
        "storage_key": "property/6767906449167727/01a03515-ed69-76c8-b260-4a0ef3cfb897.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tgh.org/?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13864056167954562457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-general-hospital",
      "poi_latitude": "27.9377069",
      "poi_longitude": "-82.45921299999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-844-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c7-7138-9b7e-15bcf0213fe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c7-7138-9b7e-15bcf0213fe1",
        "storage_key": "property/6767906449167727/01a03516-06c7-7138-9b7e-15bcf0213fe1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW92V1ZPEwogRmb3-PKEFZ8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_9307179bd080b1d187574773",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "TGH Kennedy Emergency Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a153-77ac-a2eb-4c574fdd046e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a153-77ac-a2eb-4c574fdd046e",
        "storage_key": "property/6767906449167727/01a03518-a153-77ac-a2eb-4c574fdd046e.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "https://www.tgh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16923326810559279796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tgh-kennedy-emergency-center",
      "poi_latitude": "27.9448778",
      "poi_longitude": "-82.47300349999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-660-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXaFsPtnFwogRtPI6ERK82-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_9eb81586907f3bff49eeb97f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Kennedy Walk-In Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3308 W Kennedy Blvd, Tampa, FL 33609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504468002546460201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennedy-walk-in-clinic",
      "poi_latitude": "27.9445159",
      "poi_longitude": "-82.4978196",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-874-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7YUOQ3DwogRKSZJAXzMY0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_bf30176c74b000e05e6ba8ff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa Family Health Centers",
      "poi_type": "Health and Wellness",
      "poi_address": "7814 N Dale Mabry Hwy, Tampa, FL 33614, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a508-7239-82d2-5327cf69f13d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a508-7239-82d2-5327cf69f13d",
        "storage_key": "property/6767906449167727/01a03518-a508-7239-82d2-5327cf69f13d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tfhc.org/?utm_source=GMBSocialClimb&utm_medium=TampaFamilyHealthCenters",
      "poi_directions_map_url": "https://maps.google.com/?cid=9133398988441408199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-family-health-centers",
      "poi_latitude": "28.0188183",
      "poi_longitude": "-82.5058619",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-397-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVdMFem7BwogRx1L2Of1ZwH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e2fc808ee2549c2dc87935da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "417 S Hyde Park Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cvs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15878594845523139234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "27.9398674",
      "poi_longitude": "-82.464277",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-251-2039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ba09-742b-bc53-1f9de2c9a171.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-ba09-742b-bc53-1f9de2c9a171",
        "storage_key": "property/6767906449167727/01a03518-ba09-742b-bc53-1f9de2c9a171.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM2f4DJDEwogRolrBM-IZXNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7bf7e88a43cc567508d815fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "[solidcore] Hyde Park",
      "poi_type": "Health and Wellness",
      "poi_address": "732 S Village Cir Ste F732, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a3d5-76ee-8124-55fcebe812d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a3d5-76ee-8124-55fcebe812d9",
        "storage_key": "property/6767906449167727/01a03518-a3d5-76ee-8124-55fcebe812d9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://solidcore.co/studios/hyde-park?siteId=693866&locationId=7&utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11455608896561489377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "solidcore-hyde-park",
      "poi_latitude": "27.9364216",
      "poi_longitude": "-82.4751488",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-536-4718",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7xHA-E7FwogR4SVa1Zh_-p4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_6384dbb9c3ea0e3505fc2f4f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "CrossFit Hyde Park",
      "poi_type": "Health and Wellness",
      "poi_address": "1335 W Gray St, Tampa, FL 33606, USA",
      "poi_short_description": "CrossFit box featuring classes and weightlifting in a clean facility.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a06d-713f-8929-1101a70d5cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a06d-713f-8929-1101a70d5cc5",
        "storage_key": "property/6767906449167727/01a03518-a06d-713f-8929-1101a70d5cc5.webp",
        "width": 1170,
        "height": 1154
      },
      "poi_business_url": "https://crossfithydepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3151504386554650424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-hyde-park",
      "poi_latitude": "27.94857",
      "poi_longitude": "-82.47379500000001",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 813-791-7793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYcL9GXDwogRON-szIpkvCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_c77800da9d5382503f0813b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Bella Prāṇa Yoga and Wellness Collective",
      "poi_type": "Health and Wellness",
      "poi_address": "1112 W Platt St, Tampa, FL 33606, USA",
      "poi_short_description": "Yoga sanctuary teaching asana, power and prenatal classes, plus yoga-teacher training courses.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a151-76ca-99d9-e6c6ef9445a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a151-76ca-99d9-e6c6ef9445a6",
        "storage_key": "property/6767906449167727/01a03518-a151-76ca-99d9-e6c6ef9445a6.webp",
        "width": 1000,
        "height": 564
      },
      "poi_business_url": "http://www.bellaprana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11641032076914887557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bella-pra-yoga-and-wellness-collective",
      "poi_latitude": "27.9414464",
      "poi_longitude": "-82.47134570000001",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcbNH70bDwogRhYtwQ_9AjaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_569baad7a893aa6f08517c0e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "301 S Dale Mabry Hwy, Tampa, FL 33609, USA",
      "poi_short_description": "Members-only health club offering state-of-the-art facilities, group classes, and personalized training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-e9d5-76eb-807d-e6b41681a8ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-e9d5-76eb-807d-e6b41681a8ef",
        "storage_key": "property/6767906449167727/01a03515-e9d5-76eb-807d-e6b41681a8ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=919&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11149347272221246784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "27.9417071",
      "poi_longitude": "-82.50615239999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-775-6492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiev7QhDDwogRQMU3tkVwupo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_1f7be950cb4b4a8d4785f2d6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Anderson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "802 S Rome Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Laid-back playground and garden for kids, with a splash pad and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a54e-7678-b3c4-87931600c815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a54e-7678-b3c4-87931600c815",
        "storage_key": "property/6767906449167727/01a03518-a54e-7678-b3c4-87931600c815.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.tampagov.net/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=18195506720639013668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anderson-park",
      "poi_latitude": "27.9339327",
      "poi_longitude": "-82.4772354",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-259-1608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06cd-702c-96f6-61dc88010c94",
        "storage_key": "property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaFQ0CTDwogRJNPrX_Vsg_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d4e4a71fb4712b7b6193dcfa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Water Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Highland Ave, Tampa, FL 33602, USA",
      "poi_short_description": "A riverfront park with open, green space, plus a playground, picnicking & a splash pad for children.",
      "poi_long_description": "A riverfront park with open, green space, plus a playground, picnicking & a splash pad for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a568-76e4-8fa6-3415dc443fd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a568-76e4-8fa6-3415dc443fd6",
        "storage_key": "property/6767906449167727/01a03518-a568-76e4-8fa6-3415dc443fd6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks_search_webapp/ParkDetail.aspx?nbr=148",
      "poi_directions_map_url": "https://maps.google.com/?cid=5397554133884279558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "water-works-park",
      "poi_latitude": "27.959139",
      "poi_longitude": "-82.462825",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-274-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06cd-702c-96f6-61dc88010c94",
        "storage_key": "property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ548djmTEwogRBhsdJuP250o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_86753b0812dc0068f49428e6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Julian B. Lane Riverfront Recreational Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 N Blvd, Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a70c-72cd-ab08-629083ac7cb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a70c-72cd-ab08-629083ac7cb5",
        "storage_key": "property/6767906449167727/01a03518-a70c-72cd-ab08-629083ac7cb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14835938368154246306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julian-b-lane-riverfront-recreational-center",
      "poi_latitude": "27.9542838",
      "poi_longitude": "-82.46786759999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6afKQDFwogRohxsd1fX480",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_f3c522bda581fdebc7ba01e3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Marjorie Park Yacht Basin",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "115 Columbia Dr, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a7b2-760a-bce2-4753b61d8e1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a7b2-760a-bce2-4753b61d8e1e",
        "storage_key": "property/6767906449167727/01a03518-a7b2-760a-bce2-4753b61d8e1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=11343309367574949301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marjorie-park-yacht-basin",
      "poi_latitude": "27.9333209",
      "poi_longitude": "-82.45565119999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-259-1604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eGpk5TEwogRtW2qN8WHa50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_c4c650ae55bd3d5271721e1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Davis Islands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "155 Columbia Dr, Tampa, FL 33606, USA",
      "poi_short_description": "Park with baseball and softball fields, plus a playground, basketball court, and picnic areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-aa24-73cf-978f-6aced8a92e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-aa24-73cf-978f-6aced8a92e62",
        "storage_key": "property/6767906449167727/01a03518-aa24-73cf-978f-6aced8a92e62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks-and-recreation/parks-and-facilities/playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=11750450211144617683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davis-islands-park",
      "poi_latitude": "27.9288557",
      "poi_longitude": "-82.45337289999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-274-7716",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06cd-702c-96f6-61dc88010c94",
        "storage_key": "property/6767906449167727/01a03516-06cd-702c-96f6-61dc88010c94.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRxLV5XEwogR004w4jX8EaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_02a36e4542b86b8fba5759e8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Playgrounds of Tampa",
      "poi_type": "Entertainment",
      "poi_address": "4535 S Dale Mabry Hwy, Tampa, FL 33611, USA",
      "poi_short_description": "Playful indoor activity hub for kids featuring bounce houses, slides, arcade games and playground equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-a93f-745e-bcaf-dbf1318f4883.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-a93f-745e-bcaf-dbf1318f4883",
        "storage_key": "property/6767906449167727/01a03518-a93f-745e-bcaf-dbf1318f4883.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.playgroundsoftampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11332829791422400984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playgrounds-of-tampa",
      "poi_latitude": "27.9007759",
      "poi_longitude": "-82.5071487",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-835-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_ZEWMs7cwogR2EmywaZMRp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "ec_724c58d889e4fb589d566f57",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Poe Garage",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 N Ashley Dr, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ac73-711e-892b-8e6fd4a8057b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-ac73-711e-892b-8e6fd4a8057b",
        "storage_key": "property/6767906449167727/01a03518-ac73-711e-892b-8e6fd4a8057b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tampagov.net/dept_parking/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13156215524345418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poe-garage",
      "poi_latitude": "27.9503475",
      "poi_longitude": "-82.4614935",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-274-8179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ba0e-761b-b2d2-0676496b8a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-ba0e-761b-b2d2-0676496b8a34",
        "storage_key": "property/6767906449167727/01a03518-ba0e-761b-b2d2-0676496b8a34.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5CcqInEwogRSsbqIIK9LgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_garage"
    },
    {
      "id": "ec_7a5ff874a370a2a982c2567d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Marion Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1211 N Marion St, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ac59-77ec-9497-1c28bc66f57b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-ac59-77ec-9497-1c28bc66f57b",
        "storage_key": "property/6767906449167727/01a03518-ac59-77ec-9497-1c28bc66f57b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gohart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12356063461840094640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marion-transit-center",
      "poi_latitude": "27.95561",
      "poi_longitude": "-82.45827",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ba1f-714f-a8e7-08c511cd4fcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-ba1f-714f-a8e7-08c511cd4fcb",
        "storage_key": "property/6767906449167727/01a03518-ba1f-714f-a8e7-08c511cd4fcb.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7X6-i2HEwogRsIUp2UCOeas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_a20a054786b4e6d5d445db54",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "601 N Nebraska Ave, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-acbb-73de-8ff1-a12a954f3fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-acbb-73de-8ff1-a12a954f3fda",
        "storage_key": "property/6767906449167727/01a03518-acbb-73de-8ff1-a12a954f3fda.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/tpa",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680206783434409790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "27.9526866",
      "poi_longitude": "-82.45065249999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 833-844-0830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWlYhl_EwogRPke3ZS9uGKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_cfddf09e5ff2d57143547b27",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "TECO Line Streetcar System",
      "poi_type": "Transportation & Transit",
      "poi_address": "603-611 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b0a6-76d8-a5a4-09266034c095.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-b0a6-76d8-a5a4-09266034c095",
        "storage_key": "property/6767906449167727/01a03518-b0a6-76d8-a5a4-09266034c095.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tecolinestreetcar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2872998615738422958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teco-line-streetcar-system",
      "poi_latitude": "27.9436779",
      "poi_longitude": "-82.447975",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeJCevHEwogRrhZH6wTx3ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_35a68637893b7d5efff50a7a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Kennedy Blvd @ Rome Av",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11020377693378400325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennedy-blvd--rome-av",
      "poi_latitude": "27.94479",
      "poi_longitude": "-82.47666",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-ba20-74c9-bfa2-35547870b7ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03518-ba20-74c9-bfa2-35547870b7ed",
        "storage_key": "property/6767906449167727/01a03518-ba20-74c9-bfa2-35547870b7ed.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aAGoH3DwogRRVB1qB8_8Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_689a565f10b48704ae0d8a2e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4100 George J. Bean Pkwy, Tampa, FL 33607, USA",
      "poi_short_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_long_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-f43d-725b-a603-9b23eb57e25b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-f43d-725b-a603-9b23eb57e25b",
        "storage_key": "property/6767906449167727/01a03515-f43d-725b-a603-9b23eb57e25b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampaairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816785868724491529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-international-airport",
      "poi_latitude": "27.9768646",
      "poi_longitude": "-82.5302804",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-870-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06ae-729f-a1d3-399ac559878d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06ae-729f-a1d3-399ac559878d",
        "storage_key": "property/6767906449167727/01a03516-06ae-729f-a1d3-399ac559878d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0Sek0bCwogRCdUBxgiEW3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_2abfc08f4520945dab95d539",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Moffitt USF Magnolia Campus- 12902 USF Magnolia drive Tampa, Fl Gold Valet",
      "poi_type": "Education",
      "poi_address": "12902 USF Magnolia Drive, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b0ab-712f-94df-675cda1b4964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-b0ab-712f-94df-675cda1b4964",
        "storage_key": "property/6767906449167727/01a03518-b0ab-712f-94df-675cda1b4964.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15953255382480495458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moffitt-usf-magnolia-campus--12902-usf-magnolia-drive-tampa-fl-gold-valet",
      "poi_latitude": "28.0650561",
      "poi_longitude": "-82.42173389999999",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 813-745-2081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL7lJ1p3HwogRYqPWEz9ZZd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_90354ebc3286ebea7e565e63",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "University of South Florida",
      "poi_type": "Education",
      "poi_address": "4202 E Fowler Ave, Tampa, FL 33620, USA",
      "poi_short_description": "Research university founded in 1956 with a variety of student organizations & Greek system houses.",
      "poi_long_description": "Research university founded in 1956 with a variety of student organizations & Greek system houses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b2a5-725d-a074-eeeeb9d5a6a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-b2a5-725d-a074-eeeeb9d5a6a5",
        "storage_key": "property/6767906449167727/01a03518-b2a5-725d-a074-eeeeb9d5a6a5.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.usf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12823001712777334890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-south-florida",
      "poi_latitude": "28.0622334",
      "poi_longitude": "-82.4135057",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 813-974-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06fe-729c-ba9b-547b2f5363fa",
        "storage_key": "property/6767906449167727/01a03516-06fe-729c-ba9b-547b2f5363fa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0__Gw77HwogRapBRXB509LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_4a58937858ad92a062fe45bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Port Tampa Bay",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1101 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Departure point for local & Caribbean cruises, plus educational boat tours of the harbor.",
      "poi_long_description": "Departure point for local & Caribbean cruises, plus educational boat tours of the harbor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b17b-704d-851c-ac9d615f0166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-b17b-704d-851c-ac9d615f0166",
        "storage_key": "property/6767906449167727/01a03518-b17b-704d-851c-ac9d615f0166.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://porttb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8691922585219425657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-tampa-bay",
      "poi_latitude": "27.9503837",
      "poi_longitude": "-82.4450219",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-905-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-0a57-741a-9e1b-3abb8bd0516c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-0a57-741a-9e1b-3abb8bd0516c",
        "storage_key": "property/6767906449167727/01a03516-0a57-741a-9e1b-3abb8bd0516c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8JZy_fEwogReeUyG4rpn3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_76815be8b333423fc46252de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "TECO",
      "poi_type": "Major Employers & Offices",
      "poi_address": "702 N Franklin St, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tampaelectric.com/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=402649919247362513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teco",
      "poi_latitude": "27.9501677",
      "poi_longitude": "-82.45934319999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-223-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c6-733c-98c1-4bbeb782955e",
        "storage_key": "property/6767906449167727/01a03516-06c6-733c-98c1-4bbeb782955e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6p6hYnEwogR0SmU3fd_lgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_dd4f32b5d6ceb4aff35e1c20",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Hillsborough County Tax Collector",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 E Kennedy Blvd, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-b44e-766e-8749-6b42cb5f536b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03518-b44e-766e-8749-6b42cb5f536b",
        "storage_key": "property/6767906449167727/01a03518-b44e-766e-8749-6b42cb5f536b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillstaxfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2993346978512072366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-county-tax-collector",
      "poi_latitude": "27.948334",
      "poi_longitude": "-82.45476599999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-635-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-0a57-741a-9e1b-3abb8bd0516c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-0a57-741a-9e1b-3abb8bd0516c",
        "storage_key": "property/6767906449167727/01a03516-0a57-741a-9e1b-3abb8bd0516c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbrlKovEwogRrm6zrzeBiik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_bef8dd91fbccbbb9fcaf4c0d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "Tampa City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "E Kennedy Blvd, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-fd4c-7668-84a7-bc6fd9be9188.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-fd4c-7668-84a7-bc6fd9be9188",
        "storage_key": "property/6767906449167727/01a03515-fd4c-7668-84a7-bc6fd9be9188.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tampa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8929066317482268098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-city-hall",
      "poi_latitude": "27.9477268",
      "poi_longitude": "-82.4572693",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-274-8211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-0a57-741a-9e1b-3abb8bd0516c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-0a57-741a-9e1b-3abb8bd0516c",
        "storage_key": "property/6767906449167727/01a03516-0a57-741a-9e1b-3abb8bd0516c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeS5lovEwogRwpVv7YFq6ns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_dfe5297e6304ab5068ec1279",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "poi_name": "St. Joseph's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 W Dr Martin Luther King Jr Blvd, Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03515-ef90-7718-8edd-fbcad32f715e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03515-ef90-7718-8edd-fbcad32f715e",
        "storage_key": "property/6767906449167727/01a03515-ef90-7718-8edd-fbcad32f715e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://baycare.org/locations/hospitals/st-josephs-hospital/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=St._Josephs_Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=6577266930117397633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephs-hospital",
      "poi_latitude": "27.9826011",
      "poi_longitude": "-82.4912561",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-870-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03516-06c7-7138-9b7e-15bcf0213fe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03516-06c7-7138-9b7e-15bcf0213fe1",
        "storage_key": "property/6767906449167727/01a03516-06c7-7138-9b7e-15bcf0213fe1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRhzBuzDwogRgUyS0mwlR1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_583ae971befc089e27818966",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_fbd15ef04954b061cbc86a0d",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_a5dfa26a0a04152485db2aba",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "20:00"
    },
    {
      "id": "ec_02e532b0e0b67620532c4555",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_39801ebd1f90c07baae58b4a",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_b085a26d1ca630c527c1cc0d",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e64a142d2e765f43cccf4ce2",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "day": "SUN",
      "open_time": "11:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_e51a0da2553c57668bb3cc86",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "The floorplans and common areas are openly designed and stylish. The pool areas feature cabanas, which are incredibly useful for a day by the water. The location leaves a little to be desired, but its still relatively adjacent to downtown. Maintenance staff is extremely friendly and repairs are done quickly and with a smile.",
      "date": "false",
      "title": "Noho Flats"
    },
    {
      "id": "ec_7c2b2edf0978ea1cdc157768",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Great apartments with even better amenities! Pool, gym,and a lounge with free wifi and cable t.v.'s in each building. The have events several times a month for their residents and offer valet trash. Animal friendly, gated parking lot and offer garages and storage units for rent.  Over all a great place to live!",
      "date": "false",
      "title": "Super Nice!"
    },
    {
      "id": "ec_3307c71d00f1e779c41ab6eb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Just moved out after 2 years at NoHo, and I couldn't have been happier with life there. Everything from the logistics of moving in, life at NoHo, and transitioning out (mail, bills, keys, et.c) was comfortable and smooth. Of course there are going to be some complaints with any apartment complex, but the real defining attribute of NoHo was the way that the leasing office, maintenance, and upper management handle issues. I've dealt with each of those three in my time at NoHo and was amazed at the professionalism and response quality. \nTwo real standouts are Jessica in the leasing office and Wayne in maintenance. Jessica always greeted me with a smile and name-recognition whenever I saw her on the property and was very helpful with any problems/issues that arose. Maintenance at NoHo is far better than I would have expected. Same day/next day fixes were the norm, and Wayne and his guys were always pleasant and professional.\nI highly recommend NoHo Flats and would still be living there if I didn't move out of state.",
      "date": "false",
      "title": "2 year review"
    },
    {
      "id": "ec_25a440c1d036a5ef265e3b3d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "NoHo Flats has by far the best staff/team, which makes living here so great! The staff  has continual patience with any issue and handles everything with urgency. The pool is great to lay out at, the people in the community are awesome, and the apartments are spacious. For it being such a dog friendly environment I never hear barking while inside my apartment. Im also on the second floor and there has been zero noises from above. I moved down here from Michigan and picking an apartment was a huge decision, but NoHo flats staff and community surely made my decision easy.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_73f71f03611159a43c392c29",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Great community, clean, safe, modern apartments with all must features, nice pool, fantastic location. Only thing is parking can get completely full at night in building 4 resident lot but did always find parking at the other resident lot across the street. Overall, 8.8/10 and great place to live!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0d2edb4f9235f69a2924a9a7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Caring Leasing and Maintenance staff. I really hope this team stays put! They make living here so pleasant",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_dbc76c32c6b92fbb77816ba7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Tremendous all-around experience.  A very nice property.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bd80975fd7f9e1d36640d7bb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo has a welcoming staff and courteous maintenance team. You feel like you are part of a small community rather than just a number here. Pet friendliness is a key feature I personally enjoy.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5649121afc8ce0e7383a7cca",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "We love NoHo. The staff, location, and numerous amenities are just a few reasons why!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3cb1ef860ac2240b756623a7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I came to Tampa on January 2018 I regret not leasing with them from that time. One thing that makes them better than every other community is the staff there more than amazing always willing to help great place.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_64d0941e26731c6d4540ff0e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Great location and amenities. Scooter to downtown.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_84b30570900087fd2a6beb51",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "The place you really feel at home, even when talking to staff. Everyone is so friendly and welcoming, I always feel taken care of.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ff79a36ed92a518b55a5e7dd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Such friendly staff! I always feel welcome in the office!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ef625736556a07f8d5d798a2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Great location, great leasing agent, fantastic layouts",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_cada2b7c2dd269bba1252521",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "A nice place to live where everything is done to make it work well.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b1c6e773c3ecc11b8427b245",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Excellent management and maintenance team!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b6fe60c19cb77ff0227b9856",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "I dont really have any complaints about this place.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b59d116faf6b3c9329e2ee7e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Im enjoying living here so far! Its such a lovely community and I like how people actually want to get to know each other!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_adc2b2783023cf14c9ec11fc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "great place to live",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c943ff632b15e999d6dca250",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Good place",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c863eb4b035faf9fdfec4ac8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I have been a resident of NoHo Flats for over 3 years and I have thoroughly enjoyed my time here! The staff in the leasing office is so kind- they are willing to go out of their way to make sure everyone is satisfied with their own living situations! Maintenance does a fabulous job keeping the grounds clean and the apartments in mint condition! If you are looking for a place to call home in South Tampa..I promise you wont be disappointed here!!!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_90f84ff7b3ad488750ffa015",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo flats is a community that has plenty to offer.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a9d031d0d5426fa88713eecb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Ive only been here a few days but so far so good! Fastest and easiest leasing process ever. Moved in within 5 days of viewing the apt. Matthew is the best of the best! Very professional and explained everything I needed to know. My unit has all the features I wanted! Clean and beautiful community. Cant believe I live hereeee!!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bca5fa28321ba23e86912318",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "the team at NOHO flats has been excellent",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e8a3bb1dbe2fd285da17b3d9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "The complex is located in a very convenient and ideal location. Amenities are beautiful and clean. The only issue my roommate and I face is that our downstairs neighbors are especially noisy, but that is more of a neighbor issue. The management team has responded to our concerns and reached out to them to be more courteous of their volume.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c8f2b586cac87b79698c90f7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Its a great place to live and close to many things to do",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_1b1d1db682c873142ff59efa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho is an amazing community, and the staff are always wonderfull!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_33fc364a8e0fa98b3605144b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "We have been pleased to call NoHo Flats our home for over 3 years now! Everyone in the leasing office is there to do whats best for their residents! The location is amazing- walking distance to all the great things tampa has to offer. I wouldnt trade my experiences here so far for anything!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_92ab073a531d688c8a20c91a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I am very pleased with the maintenance team and staff at Noho Flats. I am really glad to have renewed my lease here.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_731a38a317889e65bdbc0122",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Such a great community to be apart of!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_08f44f8abc89821bbdbeba2e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Perfect location!!! Close to everything.  Beautiful place to live",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_69dd7753228fb6078f5e9685",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "My experience at NoHo Flats has been amazing since day one! Glad I found a community where they value residents and actually care about the fine details.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a649da82aa1cfcde69888956",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Mordern and stylish.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d12df2d4154cb39ef0df8432",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo Flats has been a great choice! The people are friendly, the apartment is beautiful, and the location is perfect.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_889207890c8454fb5b706fc1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "While I didn't live here, my boyfriend did and i visited a lot i love this place, it's well lit, quiet despite the fact that so many young people live here and it's just all around great. Everything is nice and updated. ",
      "date": "false",
      "title": "Loved Visiting"
    },
    {
      "id": "ec_6b5bb0762fee9b9c36e07d9f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I am a new resident that just moved in love everything about the apartment! The leasing team was incredibly professional and made moving in very easy!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_db998968a53c9e33cec0ec0c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho Flats is a wonderful place to live! Besides all the great amenities, the staff is super nice, the grounds are always kept clean, and Noho provides plenty of fun and exciting events to meet your neighbors. Highly recommend!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e2768a90652ae744dbed6efe",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Very good customer service",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e538ea5abe80ca3f46f8ce47",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "This community has exceeded our expectations for apartment living! The staff is kind and clean and quick. And the apartments are just beautiful!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_60376060e44856cbb325fde4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Our favorite thing about living at Noho Flats is the staff. The entire staff is courteous, friendly and professional. We have never had an issue that they havent attempted to take care of in a timely manner. Thanks Team.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_483d89a7ae6b7f16ab7b3652",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Overall noho was a great place to live. Everything is new and its very safe.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0c0b55b21b569bc33526d666",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Beautiful apartment, very kind and attentive staff",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_53170d92ca68fc39e365c757",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Great apartment management staff, responsive maintenance service and awesome apartment layout. Could not have asked for a better home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_82b3a8ac2527abfaee8b249c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I really enjoy and feel at home here at NoHo which is so rare to experience in an apartment setting! They always go above and beyond my expectations and Im thrilled to have found a place like Noho!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_90a2ea1c2aeef4f074f1fabe",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "We are grateful to be blessed with this amazing staff that takes care of our maintenance needs efficiently. The entire staff continue to genuinely express care to ensure our satisfaction! We would absolutely be remised if we didnt take the time to also thank our Apartment Life team! They kept the fun going even during the pandemic with virtual events. Kudos to everyone! Thanks Team! -Max & Ken",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bdeb2190795645c9008ed72b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo Flats is a great apartment community. The property management team is friendly, welcoming, and overall great. The online portal and the sense of community where resident can connect is leveraged well and offers opportunities for resident-engagement. And of course, the maintenance staff is quick, efficient, and friendly. Any time I've had an issue, it's been taken care of pretty quickly. I'm more than satisfied with my living situation and renewed my lease for the 2021 year!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_10c4f918a10e3ff7132d4407",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho Flats is a great place to live! The staff is GREAT!\nThe complex is safe, with great social areas/amenities, and nice location. \nI highly recommend this complex.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a9430c0e526b39216808b521",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "We LOVE living at NoHo Flats! Things are always well kept, and the maintenance staff are all hard workers and leasing staff so kind and helpful.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a55bd505ab16b28e5cef7b49",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I have lived her for 5 years now, and I love this community! The front office staff is always so friendly, the environment is beautiful, and I love the location and all the amenities. There is lots of good energy here. Thank you.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7b3b82f847ae232c795b1368",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "The staff makes the difference here. of course the place is nice and you can find similar nice places, but they are genuinely concerned that you enjoy your living experience with Noho. The location is great too and the neighborhood evolving positively.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a1f6ff0e19bcc85da11836fe",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo has gone above and beyond to serve and provide for us! We truly love living here and recommend to our friends on a REGULAR basis.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_047b52fa8a9e1de3fcf40305",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Well maintained complex and they really try to create a community through events (and went above and beyond to keep those up virtually throughout the pandemic).",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3fd56e7c88adda1d92219c13",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "NoHo flats is a safe, well managed apartment complex with great amenities. Perfect location--in between downtown and Howard street--that is a step up from the college apartment scene.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e9c6b28213051b7227724562",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo Flats is a great place to live - the staff is kind, there are great amenities (including good study/work areas), and the location and quality of the apartments make it a prime place to live in Tampa! I couldnt have chose a better place to live.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2fefd7735948635074515cba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "The staff here has been extremely responsive and courteous. Very different from my last experience and it certainly has made me feel more than welcome. Thank you.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2425842c107fa7af45feb712",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo Flats has been an incredible community to live in, from the leasing staff to the maintenance team! Next month makes 3 years living here, and it's been amazing to see the North Hyde Park landscape change. I'm looking forward to seeing how much more the neighborhood will change. My only \"complaint\" is that I wish the appliances were updated, but everything else I'm more than satisfied with.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e293afdf578b89c56e31d0b5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho Flats is a very nice place to live. It is located in a great and safe area. Neighbors and the staff are very nice! There are many social activities organized by Noho to make their residents to feel appreciated. Living at Noho Flats makes life easier!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b5643f0de0ec5177c70d0d9e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho flats is a great place to live. It is a safe complex, located at a great area. The administrative staff is excellent, always willing to help, and the maintenance team solves the requests within a day!!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_6d1032cce90c005b5477d773",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Great place to live! We feel soo safe, and taken care of",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_059742d6db401d5df200d0f7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "The staff from office personnel and maintenance are so friendly and helpful. I love living there!!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_6e43c4de0d1698bc83949be5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Ive been living at NOHO Flats for almost 4 years and I love it here. The grounds are buildings are well maintained. The units are still very clean and new. They maintenance team is very responsive and quick to fix all requests.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b3ca50e66bef74d700b886b5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "While I was apartment hunting, I saw NoHo Flats had amazing reviews and decided to contact via contact form for a tour. Elizabeth was so quick to respond to confirm our tour and I was so surprised since most places I was looking at took about a week to reach back out to me. At tour she was very professional yet amicable. We decided we want to live here! The process was so quick and painless and the value of living here is well worth it. Id recommend it to anyone at all! I love living here already.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f4a0dd191fdbb8bd90a47717",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo Flats is a great home.  It's close to everything and anything, offers many activities, is architecturally well-designed, and is professionally managed.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_544c734d2084fe0db8735822",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Always willing to help, and great at communicating/scheduling service requests.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_71025cf0a922b26b5c31b775",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho is the best apartment complex in South Tampa, hands down!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4c7d637d6b257ed48ea6b412",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "I've lived in NoHo Flats for the past 9 or so months and so far it has been an above average experience. The amenities and impromptu events definitely help foster a community and the apartments are generally nice and have updated equipment throughout.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c9c0f3001e75f5b3d2c9619e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Best place I’ve ever lived! Living is easy at Noho Flats!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7e0a0fed2e2e19ee599de7a9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "After touring several different apartment complexes in the Hyde Park/South Tampa, I am confident I made the right choice. Everything about this complex is amazing, from the residents to the leasing office to the amenities. Elizabeth was the best! She actually cares and wants you to find the perfect apartment for your needs. When I toured she stayed late past the office closing in order to accomodate my work schedule. Live here if you want the best value for your money in South Tampa.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_44bfcb0a213e8038d37eefc3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "KatyJane was nothing short of incredible. She welcomed my family with open arms and answered any and all types of questions to ease my transition of moving. My building is quiet, but my neighbors have been extremely welcoming and even offered help while I was moving in. Having a dog friendly community with amenities such as a pool and a versatile gym were musts for me. NoHo was able to deliver all of my wants and needs including an amazing location.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_f0d2ec369896e7828bad73bc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I love Noho! My wife and I have been here for about a year and a half. Brenda and the office staff are amazing. The maintenance crew is spectacular. The CARES team has awesome events. We love it!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ed8cac7349cfadc6df8ae3e4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "This has been the best apartment experience of my life! Other properties have been dirty, not attentive, and dissappointing. NoHo has been in our experience the opposite. I am glad to call here home and love the wonderful amenities they provide!  You cannot beat the location and close proximity to so many restaurants, stores, and downtown without dealing with the traffic!",
      "date": "false",
      "title": "Friendly and attentive staff, crazy fast maintenance!"
    },
    {
      "id": "ec_baa74b21acd96e8b09603b95",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I love being so close to all of my favorite local spots!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_da3c70162b2702d7e00d696f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Overall great experience living in Noho Flats - I'm resigning again this year because its such a great place/community to live in.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_76003e274aae2d4b32b77c2f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "If you are looking for a clean place to live that is quiet and close to lots of things to do, this is the place to be.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_92afaef92e53ba0b6e7ca950",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Not good for work from home residents. Too noisy. Always something going on. The trash service is an inconvenience. The gates are constantly an issue. Other than that maintenance is always good and amenities are nice.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_12720d95071fb697f32bfa49",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "Noho Flats is a very nice place to live! It is well located, safe and the maintenance service is great!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_69a29985aaf6e2440ecfe884",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Fun place, great location and amenities. The community events are a lot fun too!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5c721df496a6c31c18d76b05",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo Flats is a gem located in S. Tampa. The community is close to downtown, and only minutes away from shopping, entertainment, and the airport. Noho has a well kept complex grounds with top of the line amenities as well as an excellent maintenance and front office staff. The community is also incredibly pet friendly with several dog parks. Noho should be your first choice when looking for an apartment in the South Tampa area.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b94d4721f1ab0735c4d18a25",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "4",
      "name": "false",
      "text": "The staff is super friendly and proactive. They made my moving experience much easier than I expected.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_00ddf445198441125cba7f21",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Noho is a great place to live. It's very convenient to both North and South Tampa. Very close to I4 and the Selmon which makes for easier commutes. The amenities are great and perfect for what I need. The pool is small and quaint with cabanas. The gym is updated and has plenty of equipment and isn't very crowded. Two dog parks and very pet friendly. I don't have any issues with parking and usually find a spot right in front of my place. Great place to live.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a5a8932556739ff918fc5455",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "NoHo flats has been the best part about moving to Tampa. Natalie from the leasing office is the absolute best! She was organized and quick to respond to any questions we had. So thankful to be apart of such a clean and safe community!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9d6dea75c18365444336dbf6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "Lived here for the past 6 years.  Love the community and location. \n\nIf it ain't broke don't fix it!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_49547c73621c73e49e213927",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "I have been at NoHo Flats for a little over 5 years now and I do like the community and how much the area around us has grown. I am happy with the leasing staff and maintenance team. Everyone is very friendly and helpful.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_dc29f1ce77f2defb4bcf58e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "rating": "5",
      "name": "false",
      "text": "One of the best and safest places near University of Tampa. Every week they have a different get togerher. The decor of the place is absolutely stunning. Must see. Pool is beautiful. The fitness center The game room Even has a barista for amazing coffee and teas. Daughter loves it here",
      "date": "false",
      "title": "Noho Flats "
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "pool-apartments-tampa-fl-noho",
      "search_query": "pool apartments tampa fl",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Tampa, FL",
      "h2_subtitle": "Discover exquisite pool apartments in Tampa, FL. Enjoy luxury living with top-tier amenities at Noho Apartments.",
      "page_copy": "Experience the ultimate in relaxation and style at the Noho Apartments, where our pool apartments in Tampa, FL offer a perfect blend of comfort and convenience. Nestled in North Hyde Park, our pet-friendly community boasts a refreshing outdoor lounge with a sparkling pool, ideal for unwinding after a long day. \n\nLocated in the vibrant heart of Tampa, our spacious apartments provide easy access to an array of local attractions. Besides the stunning pool, residents enjoy access to a business center and conference room, perfect for working professionals. Join us at Noho Apartments and dive into the ideal Tampa lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Tampa, FL",
      "seo_description": "Discover pool apartments in Tampa, FL at Noho, featuring a beautiful pool and modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-north-hyde-park-noho",
      "search_query": "pet friendly apartments north hyde park",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in North Hyde Park",
      "h2_subtitle": "Find the perfect pet friendly apartments in North Hyde Park. Noho offers amenities to cater to you and your furry friends.",
      "page_copy": "At Noho, we understand that pets are part of the family. That's why our pet friendly apartments in North Hyde Park are designed to accommodate both you and your four-legged companions. Our lush, pet-friendly community provides ample areas for play and relaxation, all set in the welcoming atmosphere of Tampa’s historic neighborhood.\n\nLiving at Noho, you’ll not only enjoy the convenience of a central location but also access to an array of modern amenities. From our business center and conference room to our vibrant outdoor lounge, you'll find everything you need to balance work and relaxation. Experience the warmth and charm of North Hyde Park at Noho, where you and your pets are always welcome.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in North Hyde Park",
      "seo_description": "Explore Noho's pet friendly apartments in North Hyde Park, offering top amenities and welcoming spaces for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "dedicated-parking-apartments-hillsborough-county-noho",
      "search_query": "dedicated parking apartments hillsborough county",
      "category": "Amenity",
      "h1_title": "Dedicated Parking Apartments in Hillsborough",
      "h2_subtitle": "Explore dedicated parking apartments in Hillsborough County. Noho Apartments offer convenience and modern living in Tampa, FL.",
      "page_copy": "Noho Apartments proudly offers dedicated parking solutions in Hillsborough County to make your life hassle-free. Our location in North Hyde Park provides residents with the convenience of reserved parking, ensuring easy access to your vehicle at all times in the bustling city of Tampa, FL.\n\nBeyond the convenience of dedicated parking, our community embraces a luxurious lifestyle with a wide range of amenities. Residents have access to a state-of-the-art business center, private conference rooms, and an inviting outdoor lounge. Whether you're driving to work or exploring Tampa, Noho Apartments offer the parking convenience you need in Hillsborough County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments in Hillsborough",
      "seo_description": "Find apartments with dedicated parking in Hillsborough County at Noho. Enjoy convenient, modern living in North Hyde Park, Tampa, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-33606-noho",
      "search_query": "fitness center apartments 33606",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 33606",
      "h2_subtitle": "Discover fitness center apartments in the 33606 area. Noho offers excellent fitness amenities and modern living in Tampa.",
      "page_copy": "At Noho Apartments, located in the sought-after 33606 zip code, we offer exceptional living with an emphasis on health and wellness. Our fitness center apartments are perfect for those who value an active lifestyle without compromising on comfort. Situated in the vibrant area of North Hyde Park, you can enjoy easy access to a cutting-edge fitness center right at your doorstep.\n\nIn addition to top-tier fitness facilities, residents benefit from a wealth of amenities designed for modern living. Gather with friends at our outdoor lounge, utilize our conference room for business needs, or take confidence in our pet-friendly community. Experience the best of Tampa with Noho Apartments, where fitness and lifestyle blend seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 33606",
      "seo_description": "Explore Noho's fitness center apartments in 33606. Enjoy modern living with top amenities in North Hyde Park, Tampa, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "clubhouse-apartments-tampa-noho",
      "search_query": "clubhouse apartments tampa",
      "category": "Amenity",
      "h1_title": "Clubhouse Apartments in Tampa",
      "h2_subtitle": "Explore clubhouse apartments in Tampa at Noho. Enjoy a vibrant community and top-notch amenities in the heart of the city.",
      "page_copy": "Welcome to Noho, where the clubhouse culture thrives in the heart of Tampa. Our clubhouse apartments offer residents a communal space that fosters connection and relaxation. Nestled in North Hyde Park, Noho presents an ideal blend of community and privacy, perfect for those seeking a social living environment.\n\nBeyond the welcoming clubhouse, Noho provides a range of amenities designed for an active and modern lifestyle. Enjoy the convenience of our business center, relax in our outdoor lounge, and bring your pets along, as we are a pet-friendly community. Experience the vibrancy of Tampa living at Noho, where comfort meets community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse Apartments in Tampa",
      "seo_description": "Discover Noho's clubhouse apartments in Tampa. Enjoy modern amenities and vibrant community living in North Hyde Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-tampa-fl-noho",
      "search_query": "one bedroom apartments in Tampa FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tampa, FL",
      "h2_subtitle": "Discover stylish one bedroom apartments in Tampa, FL. Noho offers modern living with top amenities in a prime location.",
      "page_copy": "Welcome to Noho Apartments, where you'll find stylish and spacious one bedroom apartments in Tampa, FL. Located in the bustling North Hyde Park neighborhood, our community offers the perfect blend of comfort and convenience. Each one bedroom unit is thoughtfully designed with modern finishes and open layouts, perfect for individuals or couples seeking a cozy home.\n\nLiving at Noho means access to an array of amenities, including a well-equipped business center, serene outdoor lounge, and meeting-ready conference room. Our pet-friendly community also ensures that your furry friends are welcome. Experience the best of Tampa living in our one bedroom apartments, where every detail is crafted with your comfort in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Tampa, FL",
      "seo_description": "Explore Noho's one bedroom apartments in Tampa, FL. Enjoy modern amenities and stylish living in North Hyde Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-north-hyde-park-noho",
      "search_query": "two bedroom rentals in North Hyde Park",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in North Hyde Park",
      "h2_subtitle": "Experience modern living with our two bedroom rentals in North Hyde Park. Noho offers comfort and style in Tampa's vibrant scene.",
      "page_copy": "Discover the perfect blend of comfort and style with our two bedroom rentals in North Hyde Park, offered at Noho Apartments. Perfectly situated in a vibrant Tampa neighborhood, our spacious two bedroom units provide the ideal setting for shared living or extra space for an office or guests. \n\nResidents at Noho enjoy a range of amenities that enhance their lifestyle, including a parking facility, business center, and inviting outdoor lounge. Plus, our pet-friendly policy ensures that all family members, including furry ones, feel at home. Experience elevated living in North Hyde Park with Noho's sophisticated two bedroom rentals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in North Hyde Park",
      "seo_description": "Explore spacious two bedroom rentals at Noho in North Hyde Park. Enjoy modern amenities and a prime Tampa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "three-bedroom-apts-hillsborough-county-noho",
      "search_query": "three bedroom apts Hillsborough County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apts in Hillsborough County",
      "h2_subtitle": "Explore spacious three bedroom apts in Hillsborough County. Noho offers a blend of comfort and modern amenities in Tampa.",
      "page_copy": "At Noho, you'll find inviting three bedroom apts in Hillsborough County that cater to families and roommates alike. Located in the lively North Hyde Park neighborhood, our spacious apartments offer a perfect balance of style and functionality.\n\nResidents can enjoy a wide array of amenities such as ample parking, a fully equipped business center, and a cozy outdoor lounge. The pet-friendly community ensures that every member of the household, including pets, feels welcome and comfortable. Choose Noho for your next home in Hillsborough County and experience the best of modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apts in Hillsborough County",
      "seo_description": "Discover Noho's spacious three bedroom apts in Hillsborough County. Enjoy modern living with top amenities in Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-tampa-fl-noho",
      "search_query": "apartments near university of tampa fl",
      "category": "School",
      "h1_title": "Apartments Near University of Tampa, FL",
      "h2_subtitle": "Find stylish apartments near the University of Tampa, FL. Noho offers convenience and modern living just a stone's throw away.",
      "page_copy": "Looking for apartments near the University of Tampa, FL? Noho Apartments offers a prime location perfect for students and professionals who want to be close to campus without sacrificing style and comfort. Nestled in the dynamic North Hyde Park neighborhood, our community provides modern living spaces designed to match your lifestyle. \n\nEnjoy an array of amenities including a business center, outdoor lounge, and convenient parking facilities. Our pet-friendly environment ensures all members of the family, furry or otherwise, feel right at home. Choose Noho for the best experience in proximity to the University of Tampa, blending convenience with contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Tampa, FL",
      "seo_description": "Explore Noho's apartments near the University of Tampa, FL. Enjoy modern amenities and convenient living in North Hyde Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "apartments-close-hillsborough-college-dale-mabry-noho",
      "search_query": "apartments close to hillsborough college dale mabry campus tampa",
      "category": "School",
      "h1_title": "Apts Close to Hillsborough College Dale Mabry",
      "h2_subtitle": "Discover convenient apartments close to Hillsborough College Dale Mabry campus. Noho provides the ideal living in Tampa.",
      "page_copy": "If you are seeking quality apartments close to Hillsborough College Dale Mabry campus, Noho Apartments in North Hyde Park stands as a perfect choice. Offering proximity and comfort, our community is ideal for those attending or working near the college. Our thoughtfully designed living spaces ensure a serene environment amidst the bustling city life.\n\nAt Noho, you will benefit from an array of amenities including a comprehensive business center, ample parking, and a beautifully arranged outdoor lounge area. Our pet-friendly policy means you don't have to leave your furry friends behind. Choose Noho to combine convenience with luxury in the heart of Tampa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Hillsborough College Dale Mabry",
      "seo_description": "Find apts near Hillsborough College Dale Mabry campus at Noho. Enjoy modern amenities and a prime location in North Hyde Park, Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "apartments-near-st-josephs-hospital-north-hyde-park-noho",
      "search_query": "apartments near St. Joseph's Hospital North Hyde Park",
      "category": "Hospital",
      "h1_title": "Apts Near St. Joseph's Hospital North Hyde Park",
      "h2_subtitle": "Noho offers premium apartments near St. Joseph's Hospital in North Hyde Park. Live in comfort and style in Tampa's vibrant community.",
      "page_copy": "Discover Noho Apartments, featuring modern living spaces just minutes from St. Joseph's Hospital in the heart of North Hyde Park. Our prime location makes it easy for healthcare professionals and patients to enjoy both proximity and privacy.\n\nWith a range of upscale amenities, including a business center, conference room, and pet-friendly policies, Noho ensures every resident feels comfortable and at home. The outdoor lounge provides a perfect retreat after a busy day. Whether you're seeking a short commute or a serene environment, Noho delivers an exceptional living experience near St. Joseph's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near St. Joseph's Hospital North Hyde Park",
      "seo_description": "Explore Noho's apts near St. Joseph's Hospital in North Hyde Park. Enjoy modern amenities and a convenient Tampa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "apartments-near-tampa-riverwalk-noho",
      "search_query": "apartments near Tampa Riverwalk",
      "category": "Park",
      "h1_title": "Apts Near Tampa Riverwalk",
      "h2_subtitle": "Discover exceptional apartments near Tampa Riverwalk at Noho. Enjoy easy access to this vibrant waterfront area.",
      "page_copy": "Noho Apartments offer a lively and convenient living experience near the Tampa Riverwalk, perfect for those who appreciate a blend of urban life and nature. Located in North Hyde Park, our community combines stylish living with unmatched access to the scenic riverwalk area.\n\nResidents at Noho enjoy amenities like a well-equipped business center, ample parking, and a relaxing outdoor lounge. It's a pet-friendly haven, making it easy for everyone in the family—including four-legged members—to feel right at home. With the Riverwalk just steps away, enjoy a lifestyle of leisure and activity right outside your door.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Tampa Riverwalk",
      "seo_description": "Explore Noho's apts near Tampa Riverwalk. Enjoy modern amenities in North Hyde Park with easy access to waterfront attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "noho-apartments-close-curtis-hixon-waterfront-park",
      "search_query": "Noho apartments close to Curtis Hixon Waterfront Park",
      "category": "Park",
      "h1_title": "Noho Apts Near Curtis Hixon Park",
      "h2_subtitle": "Experience Noho's luxury apartments close to Curtis Hixon Waterfront Park. Perfectly located in North Hyde Park, Tampa.",
      "page_copy": "Noho Apartments are the ideal choice for those seeking stylish living close to Curtis Hixon Waterfront Park. Located in North Hyde Park, our community offers the perfect blend of city life and relaxing park views, just a short walk away from one of Tampa's most popular green spaces.\n\nOur residents enjoy unmatched amenities such as a spacious business center, ample parking facilities, and a charming outdoor lounge area. As a pet-friendly community, Noho makes it easy for you and your furry companions to feel right at home while enjoying the scenic surroundings. Come live where convenience meets luxury, near Curtis Hixon Waterfront Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Noho Apts Near Curtis Hixon Park",
      "seo_description": "Discover Noho apartments near Curtis Hixon Waterfront Park. Enjoy modern living in North Hyde Park, close to Tampa's vibrant attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "north-hyde-park-apartments-near-julian-b-lane-riverfront-park",
      "search_query": "North Hyde Park apartments by Julian B. Lane Riverfront Park",
      "category": "Park",
      "h1_title": "North Hyde Park Apts Near Julian B. Lane Park",
      "h2_subtitle": "Discover Noho, North Hyde Park's premier apartments by Julian B. Lane Riverfront Park. Enjoy urban living in a serene setting.",
      "page_copy": "Located in North Hyde Park, Noho offers residents luxury apartments just moments away from the scenic Julian B. Lane Riverfront Park. Our vibrant community provides a perfect balance of urban excitement and natural beauty, with the park offering ample opportunities for outdoor recreation and relaxation.\n\nAt Noho, you'll find a range of top-notch amenities, including a state-of-the-art business center, convenient parking, and inviting outdoor lounge areas. As a pet-friendly community, we ensure that all members of your household are comfortable and content. Experience the best of Tampa living with nature, culture, and convenience at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Hyde Park Apts Near Julian B. Lane Park",
      "seo_description": "Explore Noho's North Hyde Park apts near Julian B. Lane Riverfront Park. Luxury living with easy access to Tampa's natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "apartments-near-tampa-international-airport-noho",
      "search_query": "apartments near tampa international airport",
      "category": "Transit",
      "h1_title": "Apts Near Tampa Intl Airport",
      "h2_subtitle": "Noho offers ideal apartments near Tampa International Airport, situated in North Hyde Park, combining convenience with comfort.",
      "page_copy": "For frequent flyers and travel enthusiasts, Noho Apartments provide the perfect home base near Tampa International Airport. Situated in the heart of North Hyde Park, our community ensures residents enjoy seamless access to the airport while still benefiting from the vibrant local culture.\n\nResidents at Noho are treated to a host of amenities, including a modern business center, easy parking options, and an inviting outdoor lounge perfect for relaxation. As a pet-friendly community, we cater to all your lifestyle needs with style and ease. Step into a world where travel and comfort harmonize beautifully at Noho.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Tampa Intl Airport",
      "seo_description": "Discover Noho's apts near Tampa International Airport. Enjoy comfort and convenience in North Hyde Park with seamless travel access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "apartments-close-to-airport-maintenance-department-tampa-fl-noho",
      "search_query": "apartments close to airport maintenance department tampa fl",
      "category": "Transit",
      "h1_title": "Apts Close to Tampa Airport Maintenance",
      "h2_subtitle": "Find Noho, your home for apartments close to the Airport Maintenance Department in Tampa, FL. Ideal for workers and travelers alike.",
      "page_copy": "If you work at or frequently visit the Tampa Airport Maintenance Department, Noho Apartments may be the perfect living option for you. Conveniently located in North Hyde Park, our community offers quick access to the airport, making travel or commuting to the maintenance department a breeze.\n\nNoho is equipped with top-tier amenities including a comprehensive business center, ample parking, and a cozy outdoor lounge area, enhancing your living experience. As a pet-friendly community, we ensure every resident, including furry friends, is comfortable. Choose Noho and enjoy proximity and lifestyle in perfect harmony.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Tampa Airport Maintenance",
      "seo_description": "Explore Noho's apts near Tampa's Airport Maintenance Department. Convenient location in North Hyde Park ideal for workers and visitors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167727",
      "source": "generator",
      "page_item_url": "noho-apartments-near-hattricks-north-hyde-park",
      "search_query": "noho apartments near hattricks north hyde park",
      "category": "Transit",
      "h1_title": "Noho Apts by Hattricks in North Hyde Park",
      "h2_subtitle": "Experience the luxury of Noho Apartments near Hattricks in North Hyde Park, where comfort meets vibrant local culture.",
      "page_copy": "Nestled in North Hyde Park, Noho Apartments offer more than just a place to live; they provide a lifestyle. Located near the popular Hattricks bar and restaurant, residents can enjoy an exciting social scene just steps from their door. Whether you're meeting friends for a casual night out or enjoying the local fare, Hattricks is a neighborhood favorite.\n\nNoho is designed with modern living in mind, featuring amenities like a comprehensive business center, convenient parking, and relaxing outdoor lounge spaces. As a pet-friendly community, we're committed to making even our furry residents feel at home. Discover a vibrant mix of comfort and culture at Noho, where every day is an opportunity to explore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a large swimming pool and cabanas.",
        "public_id": "01a03516-9c58-73b1-957b-bb8c5f06dbcd",
        "storage_key": "property/6767906449167727/01a03516-9c58-73b1-957b-bb8c5f06dbcd.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Noho Apts by Hattricks in North Hyde Park",
      "seo_description": "Discover Noho Apartments near Hattricks in North Hyde Park. Enjoy vibrant local living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImJKQWw2VGJUWnBGTzh3eUtVN1lhTUE9PSIsInZhbHVlIjoiR2NSUlAvN05pY2JWeEFhOEhkMnRQdz09IiwibWFjIjoiNGViZmZmN2VmMDM5MGY4MTgyMDgzMzM3ZGUwM2I0YjQ0OGFiYjE2Yjk3ZGM2NWY4NzU5ZTczYWY5M2Y4YTA2ZCJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImJKQWw2VGJUWnBGTzh3eUtVN1lhTUE9PSIsInZhbHVlIjoiR2NSUlAvN05pY2JWeEFhOEhkMnRQdz09IiwibWFjIjoiNGViZmZmN2VmMDM5MGY4MTgyMDgzMzM3ZGUwM2I0YjQ0OGFiYjE2Yjk3ZGM2NWY4NzU5ZTczYWY5M2Y4YTA2ZCJ9",
  "custom_audioeye_site_id": "19b8acd8-213c-40a7-be84-bddf6f36f26a",
  "custom_audioeye_site_hash": "35d1f3414a7e7f0956b639d462bf05c6"
};

export const generatedAt = '2026-09-10T15:14:07.128Z';
